/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис реализует функционал управления приборами учёта(ПУ)
 */

/**
 * Сервис приборов учёта (ПУ).
 * Авторизация:
 *   - Authorization: Bearer token.
 *   - X-Api-Key: apiKey
 */
export class DeviceServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  // method PostDeviceFullDuplex(bidirectional streams) not supported yet

  /**
   * Метод получения ПУ.
   * Разрешения: telemetry_control:device:card, telemetry_control:device:card:own.
   * Метод доступен для: Token: admin, service, bti, seller, application, owner, employee, master. При наличии разрешений.
   * Метод доступен для: ApiKey: При наличии разрешений
   */
  GetDevice = (req: GetDeviceRequestDto, init?: RequestInit): Promise<GetDeviceResponseDto> => {
    return fm.request<GetDeviceRequestDto, GetDeviceResponseDto>(`${this.host}/telemetry_control/api/v1/device/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка приборов учета.
   * Разрешения: telemetry_control:device:list, telemetry_control:device:list:own.
   * Метод доступен для: Token: admin, service, bti, seller, application, owner, employee, master. При наличии разрешений.
   * Метод доступен для: ApiKey: При наличии разрешений
   */
  GetDeviceList = (req?: GetDeviceListRequestDto, init?: RequestInit): Promise<GetDeviceListResponseDto[]> => {
    return fm.list<GetDeviceListRequestDto, GetDeviceListResponseDto>(`${this.host}/telemetry_control/api/v1/device/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества приборов учета.
   * Разрешения: telemetry_control:device:list, telemetry_control:device:list:own.
   * Метод доступен для: Token: admin, service, bti, seller, application, owner, employee, master. При наличии разрешений.
   * Метод доступен для: ApiKey: При наличии разрешений
   */
  GetDeviceCount = (req?: GetDeviceCountRequestDto, init?: RequestInit): Promise<GetDeviceCountResponseDto> => {
    return fm.request<GetDeviceCountRequestDto, GetDeviceCountResponseDto>(`${this.host}/telemetry_control/api/v1/device/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод замены прибора учета.
   * Создает ПУ и привязывает его индикаторы к ТУ исходного ПУ.
   * Разрешения: telemetry_control:device:save, telemetry_control:device:save:own.
   * Метод доступен для: Token: admin, service, bti, seller, application, owner, employee. При наличии разрешений
   */
  PostDeviceReplace = (req: PostDeviceReplaceRequestDto, init?: RequestInit): Promise<PostDeviceReplaceResponseDto> => {
    return fm.request<PostDeviceReplaceRequestDto, PostDeviceReplaceResponseDto>(`${this.host}/telemetry_control/api/v1/device/replace`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод сохранения прибора учета.
   * Поддерживает создание и обновление.
   * Разрешения: telemetry_control:device:save, telemetry_control:device:save:own.
   * Метод доступен для: Token: admin, service, bti, seller, application, owner, employee. При наличии разрешений
   */
  PostDevice = (req: PostDeviceRequestDto, init?: RequestInit): Promise<PostDeviceResponseDto> => {
    return fm.request<PostDeviceRequestDto, PostDeviceResponseDto>(`${this.host}/telemetry_control/api/v1/device`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления прибора учета.
   * Разрешения: telemetry_control:device:remove, telemetry_control:device:remove:own.
   * Метод доступен для: Token: admin, service, bti, seller, application, owner, employee. При наличии разрешений
   */
  DeleteDevice = (req: DeleteDeviceRequestDto, init?: RequestInit): Promise<DeleteDeviceResponseDto> => {
    return fm.request<DeleteDeviceRequestDto, DeleteDeviceResponseDto>(`${this.host}/telemetry_control/api/v1/device/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод сохранения индикатора.
   * Поддерживает создание и обновление.
   * Метод доступен для: Token: admin, service, bti, seller, application, owner, employee. Без учета разрешений
   */
  PostDeviceIndicator = (req: PostDeviceIndicatorRequestDto, init?: RequestInit): Promise<PostDeviceIndicatorResponseDto> => {
    return fm.request<PostDeviceIndicatorRequestDto, PostDeviceIndicatorResponseDto>(`${this.host}/telemetry_control/api/v1/device/indicator`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения индикатора.
   * Метод доступен для: Token: admin, service, bti, seller, application, owner, employee. Без учета разрешений
   */
  GetDeviceIndicator = (req: GetDeviceIndicatorRequestDto, init?: RequestInit): Promise<GetDeviceIndicatorResponseDto> => {
    return fm.request<GetDeviceIndicatorRequestDto, GetDeviceIndicatorResponseDto>(`${this.host}/telemetry_control/api/v1/device/indicator/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка индикаторов.
   * Метод доступен для: Token: admin, service, bti, seller, application, owner, employee. Без учета разрешений
   */
  GetDeviceIndicatorList = (req?: GetDeviceIndicatorListRequestDto, init?: RequestInit): Promise<GetDeviceIndicatorListResponseDto[]> => {
    return fm.list<GetDeviceIndicatorListRequestDto, GetDeviceIndicatorListResponseDto>(`${this.host}/telemetry_control/api/v1/device/indicator/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества индикаторов.
   * Метод доступен для: Token: admin, service, bti, seller, application, owner, employee. Без учета разрешений
   */
  GetDeviceIndicatorCount = (req?: GetDeviceIndicatorCountRequestDto, init?: RequestInit): Promise<GetDeviceIndicatorCountResponseDto> => {
    return fm.request<GetDeviceIndicatorCountRequestDto, GetDeviceIndicatorCountResponseDto>(`${this.host}/telemetry_control/api/v1/device/indicator/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления индикаторa.
   * Метод доступен для: Token: admin, service, bti, seller, application, owner, employee. Без учета разрешений
   */
  DeleteDeviceIndicator = (req: DeleteDeviceIndicatorRequestDto, init?: RequestInit): Promise<DeleteDeviceIndicatorResponseDto> => {
    return fm.request<DeleteDeviceIndicatorRequestDto, DeleteDeviceIndicatorResponseDto>(`${this.host}/telemetry_control/api/v1/device/indicator/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка связей индикаторов и ТУ.
   * Метод доступен для: Token: admin, service, bti, seller, application, owner, employee. Без учета разрешений
   */
  GetDeviceIndicatorMetricPointList = (req?: GetDeviceIndicatorMetricPointListRequestDto, init?: RequestInit): Promise<GetDeviceIndicatorMetricPointListResponseDto[]> => {
    return fm.list<GetDeviceIndicatorMetricPointListRequestDto, GetDeviceIndicatorMetricPointListResponseDto>(`${this.host}/telemetry_control/api/v1/device/indicator/metric_point/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества связей индикаторов и ТУ.
   * Метод доступен для: Token: admin, service, bti, seller, application, owner, employee. Без учета разрешений
   */
  GetDeviceIndicatorMetricPointCount = (req?: GetDeviceIndicatorMetricPointCountRequestDto, init?: RequestInit): Promise<GetDeviceIndicatorMetricPointCountResponseDto> => {
    return fm.request<GetDeviceIndicatorMetricPointCountRequestDto, GetDeviceIndicatorMetricPointCountResponseDto>(`${this.host}/telemetry_control/api/v1/device/indicator/metric_point/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод сохранения связи индикаторов и ТУ.
   * Поддерживает только создание связи.
   * Метод доступен для: Token: admin, service, bti, seller, application, owner, employee. Без учета разрешений
   */
  PutDeviceIndicatorMetricPointAttach = (req: PutDeviceIndicatorMetricPointAttachRequestDto, init?: RequestInit): Promise<PutDeviceIndicatorMetricPointAttachResponseDto> => {
    return fm.request<PutDeviceIndicatorMetricPointAttachRequestDto, PutDeviceIndicatorMetricPointAttachResponseDto>(`${this.host}/telemetry_control/api/v1/device/indicator/${encodeURIComponent(req.deviceIndicatorMetricPoint.indicatorId)}/metric_point/${encodeURIComponent(req.deviceIndicatorMetricPoint.metricPointId)}/attach`, { ...init, method: "PUT", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления связи индикаторов и ТУ.
   * Метод доступен для: Token: admin, service, bti, seller, application, owner, employee. Без учета разрешений
   */
  PutDeviceIndicatorMetricPointDetach = (req: PutDeviceIndicatorMetricPointDetachRequestDto, init?: RequestInit): Promise<PutDeviceIndicatorMetricPointDetachResponseDto> => {
    return fm.request<PutDeviceIndicatorMetricPointDetachRequestDto, PutDeviceIndicatorMetricPointDetachResponseDto>(`${this.host}/telemetry_control/api/v1/device/indicator/${encodeURIComponent(req.deviceIndicatorMetricPoint.indicatorId)}/metric_point/${encodeURIComponent(req.deviceIndicatorMetricPoint.metricPointId)}/detach`, { ...init, method: "PUT", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка связей ПУ и группы пользователя.
   * Метод доступен для: Token: admin, service, bti, seller. Без учета разрешений
   */
  GetDeviceGroupList = (req?: GetDeviceGroupListRequestDto, init?: RequestInit): Promise<GetDeviceGroupListResponseDto[]> => {
    return fm.list<GetDeviceGroupListRequestDto, GetDeviceGroupListResponseDto>(`${this.host}/telemetry_control/api/v1/device/group/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества связей ПУ и группы пользователя.
   * Метод доступен для: Token: admin, service, bti, seller. Без учета разрешений
   */
  GetDeviceGroupCount = (req?: GetDeviceGroupCountRequestDto, init?: RequestInit): Promise<GetDeviceGroupCountResponseDto> => {
    return fm.request<GetDeviceGroupCountRequestDto, GetDeviceGroupCountResponseDto>(`${this.host}/telemetry_control/api/v1/device/group/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод сохранения связей ПУ и группы пользователя.
   * Поддерживает только создание.
   * Метод доступен для: Token: admin, service, bti, seller. Без учета разрешений
   */
  PutDeviceGroupAttach = (req: PutDeviceGroupAttachRequestDto, init?: RequestInit): Promise<PutDeviceGroupAttachResponseDto> => {
    return fm.request<PutDeviceGroupAttachRequestDto, PutDeviceGroupAttachResponseDto>(`${this.host}/telemetry_control/api/v1/device/${encodeURIComponent(req.deviceGroup.deviceId)}/group/${encodeURIComponent(req.deviceGroup.groupId)}/attach`, { ...init, method: "PUT", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления связей ПУ и группы пользователя.
   * Метод доступен для: Token: admin, service, bti, seller. Без учета разрешений
   */
  PutDeviceGroupDetach = (req: PutDeviceGroupDetachRequestDto, init?: RequestInit): Promise<PutDeviceGroupDetachResponseDto> => {
    return fm.request<PutDeviceGroupDetachRequestDto, PutDeviceGroupDetachResponseDto>(`${this.host}/telemetry_control/api/v1/device/${encodeURIComponent(req.deviceGroup.deviceId)}/group/${encodeURIComponent(req.deviceGroup.groupId)}/detach`, { ...init, method: "PUT", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Справочник типов учёта
 */
export enum DeviceMetricPointAccountingType {
  /**
   * Значение не указано
   */
  ACCOUNTING_TYPE_UNKNOWN = "ACCOUNTING_TYPE_UNKNOWN",
  /**
   * Коммерческий учёт
   */
  COMMERCIAL = "COMMERCIAL",
  /**
   * Технический учёт
   */
  TECHNICAL = "TECHNICAL",
}
/**
 * Справочник типов учёта
 */
export type DeviceMetricPointAccountingTypeResponseEnum = keyof typeof DeviceMetricPointAccountingType
/**
 * Справочник типов учёта
 */
export type DeviceMetricPointAccountingTypeRequestEnum = Exclude<DeviceMetricPointAccountingTypeResponseEnum, "ACCOUNTING_TYPE_UNKNOWN">;

/**
 * Справочние типов энергоресурсов
 */
export enum DeviceMetricPointMetricType {
  /**
   * Значение не указано
   */
  METRIC_TYPE_UNKNOWN = "METRIC_TYPE_UNKNOWN",
  /**
   * Горячая вода
   */
  HOT_WATER = "HOT_WATER",
  /**
   * Холодная вода
   */
  COLD_WATER = "COLD_WATER",
  /**
   * Теплоэнергия
   */
  HEAT = "HEAT",
  /**
   * Газ
   */
  GAS = "GAS",
  /**
   * Электроэнергия
   */
  ELECTRICITY = "ELECTRICITY",
}
/**
 * Справочние типов энергоресурсов
 */
export type DeviceMetricPointMetricTypeResponseEnum = keyof typeof DeviceMetricPointMetricType
/**
 * Справочние типов энергоресурсов
 */
export type DeviceMetricPointMetricTypeRequestEnum = Exclude<DeviceMetricPointMetricTypeResponseEnum, "METRIC_TYPE_UNKNOWN">;

/**
 * Справочник типов номиналов первичных токов.
 * У выпускаемых трансформаторов тока (А)
 */
export enum DeviceMetricPointPrimaryCurrentType {
  /**
   * Значение не указано
   */
  PRIMARY_CURRENT_TYPE_UNKNOWN = "PRIMARY_CURRENT_TYPE_UNKNOWN",
  /**
   * 1 (А)
   */
  TT1A = "TT1A",
  /**
   * 5 (А)
   */
  TT5A = "TT5A",
  /**
   * 10 (А)
   */
  TT10A = "TT10A",
  /**
   * 15 (А)
   */
  TT15A = "TT15A",
  /**
   * 20 (А)
   */
  TT20A = "TT20A",
  /**
   * 30 (А)
   */
  TT30A = "TT30A",
  /**
   * 40 (А)
   */
  TT40A = "TT40A",
  /**
   * 50 (А)
   */
  TT50A = "TT50A",
  /**
   * 75 (А)
   */
  TT75A = "TT75A",
  /**
   * 80 (А)
   */
  TT80A = "TT80A",
  /**
   * 100 (А)
   */
  TT100A = "TT100A",
  /**
   * 150 (А)
   */
  TT150A = "TT150A",
  /**
   * 200 (А)
   */
  TT200A = "TT200A",
  /**
   * 300 (А)
   */
  TT300A = "TT300A",
  /**
   * 400 (А)
   */
  TT400A = "TT400A",
  /**
   * 500 (А)
   */
  TT500A = "TT500A",
  /**
   * 600 (А)
   */
  TT600A = "TT600A",
  /**
   * 750 (А)
   */
  TT750A = "TT750A",
  /**
   * 800 (А)
   */
  TT800A = "TT800A",
  /**
   * 1000 (А)
   */
  TT1000A = "TT1000A",
  /**
   * 1200 (А)
   */
  TT1200A = "TT1200A",
  /**
   * 1500 (А)
   */
  TT1500A = "TT1500A",
  /**
   * 2000 (А)
   */
  TT2000A = "TT2000A",
}
/**
 * Справочник типов номиналов первичных токов.
 * У выпускаемых трансформаторов тока (А)
 */
export type DeviceMetricPointPrimaryCurrentTypeResponseEnum = keyof typeof DeviceMetricPointPrimaryCurrentType
/**
 * Справочник типов номиналов первичных токов.
 * У выпускаемых трансформаторов тока (А)
 */
export type DeviceMetricPointPrimaryCurrentTypeRequestEnum = Exclude<DeviceMetricPointPrimaryCurrentTypeResponseEnum, "PRIMARY_CURRENT_TYPE_UNKNOWN">;

/**
 * Справочник типов статусов
 */
export enum DeviceMetricPointStatusType {
  /**
   * Значение не указано
   */
  STATUS_TYPE_UNKNOWN = "STATUS_TYPE_UNKNOWN",
  /**
   * Активная
   */
  ACTIVE = "ACTIVE",
  /**
   * Не активная
   * @deprecated
   */
  WRONG = "WRONG",
  /**
   * Архивная
   */
  ARCHIVE = "ARCHIVE",
}
/**
 * Справочник типов статусов
 */
export type DeviceMetricPointStatusTypeResponseEnum = keyof typeof DeviceMetricPointStatusType
/**
 * Справочник типов статусов
 */
export type DeviceMetricPointStatusTypeRequestEnum = Exclude<DeviceMetricPointStatusTypeResponseEnum, "STATUS_TYPE_UNKNOWN">;

/**
 * Справочник типов трубопроводов
 */
export enum DevicePipeType {
  /**
   * Значение не указано
   */
  PIPE_TYPE_UNKNOWN = "PIPE_TYPE_UNKNOWN",
  /**
   * Подающий
   */
  INFEED = "INFEED",
  /**
   * Циркуляционный
   */
  CIRCULATING = "CIRCULATING",
}
/**
 * Справочник типов трубопроводов
 */
export type DevicePipeTypeResponseEnum = keyof typeof DevicePipeType
/**
 * Справочник типов трубопроводов
 */
export type DevicePipeTypeRequestEnum = Exclude<DevicePipeTypeResponseEnum, "PIPE_TYPE_UNKNOWN">;

/**
 * Справочник типов тарифных планов
 */
export enum DevicePlanType {
  /**
   * Значение не указано
   */
  PLAN_TYPE_UNKNOWN = "PLAN_TYPE_UNKNOWN",
  /**
   * Однотарифный
   */
  SINGLE = "SINGLE",
  /**
   * Двухтарифный
   */
  DOUBLE = "DOUBLE",
  /**
   * Трёхтарифный
   */
  TRIPLE = "TRIPLE",
}
/**
 * Справочник типов тарифных планов
 */
export type DevicePlanTypeResponseEnum = keyof typeof DevicePlanType
/**
 * Справочник типов тарифных планов
 */
export type DevicePlanTypeRequestEnum = Exclude<DevicePlanTypeResponseEnum, "PLAN_TYPE_UNKNOWN">;

/**
 * Справочник типов номинальных нагрузок вторичных обмоток.
 * У трансформаторов тока (В*А)
 */
export enum DeviceSecondaryCurrentType {
  /**
   * Значение не указано
   */
  SECONDARY_CURRENT_TYPE_UNKNOWN = "SECONDARY_CURRENT_TYPE_UNKNOWN",
  /**
   * 1 (А)
   */
  TT1A = "TT1A",
  /**
   * 2 (А)
   */
  TT2A = "TT2A",
  /**
   * 5 (А)
   */
  TT5A = "TT5A",
}
/**
 * Справочник типов номинальных нагрузок вторичных обмоток.
 * У трансформаторов тока (В*А)
 */
export type DeviceSecondaryCurrentTypeResponseEnum = keyof typeof DeviceSecondaryCurrentType
/**
 * Справочник типов номинальных нагрузок вторичных обмоток.
 * У трансформаторов тока (В*А)
 */
export type DeviceSecondaryCurrentTypeRequestEnum = Exclude<DeviceSecondaryCurrentTypeResponseEnum, "SECONDARY_CURRENT_TYPE_UNKNOWN">;

/**
 * Справочник типов статусов
 */
export enum DeviceStatusType {
  /**
   * Значение не указано
   */
  STATUS_TYPE_UNKNOWN = "STATUS_TYPE_UNKNOWN",
  /**
   * Получен клиентом, еще не сконфигурирован
   */
  RECEIVED = "RECEIVED",
  /**
   * Сконфигурирован клиентом, активен
   */
  ACTIVE = "ACTIVE",
  /**
   * Обработан клиентом, возникла ошибка
   */
  WRONG = "WRONG",
  /**
   * Переведен в архивный статус
   */
  ARCHIVE = "ARCHIVE",
  /**
   * Удален
   */
  DELETE = "DELETE",
  /**
   * Отсоединен
   */
  UNLINK = "UNLINK",
}
/**
 * Справочник типов статусов
 */
export type DeviceStatusTypeResponseEnum = keyof typeof DeviceStatusType
/**
 * Справочник типов статусов
 */
export type DeviceStatusTypeRequestEnum = Exclude<DeviceStatusTypeResponseEnum, "STATUS_TYPE_UNKNOWN">;

/**
 * Справочник типов приборов учёта(ПУ)
 */
export enum DeviceType {
  /**
   * Значение не указано
   */
  TYPE_UNKNOWN = "TYPE_UNKNOWN",
  /**
   * Коммуникационный модуль
   */
  HUB = "HUB",
  /**
   * Счетчик импульсов - регистратор
   */
  PULSE_COUNTER_RECORDER = "PULSE_COUNTER_RECORDER",
  /**
   * Счетчик импульсов - регистратор LoRaWAN
   */
  PULSE_COUNTER_RECORDER_LR = "PULSE_COUNTER_RECORDER_LR",
  /**
   * Прибор учета расхода коммунальных услуг
   */
  METERING_DEVICE = "METERING_DEVICE",
  /**
   * Конвертер интерфейсов
   */
  INTERFACE_CONVERTER = "INTERFACE_CONVERTER",
  /**
   * M-BUS концентратор
   */
  M_BUS_HUB = "M_BUS_HUB",
  /**
   * Модуль связи LoRaWAN
   */
  COMMUNICATION_MODULE_LR = "COMMUNICATION_MODULE_LR",
  /**
   * Базовая станция LoRaWAN
   */
  BASE_LR = "BASE_LR",
}
/**
 * Справочник типов приборов учёта(ПУ)
 */
export type DeviceTypeResponseEnum = keyof typeof DeviceType
/**
 * Справочник типов приборов учёта(ПУ)
 */
export type DeviceTypeRequestEnum = Exclude<DeviceTypeResponseEnum, "TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки
 */
export enum DeviceGroupPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки
 */
export type DeviceGroupPagingDirectionTypeResponseEnum = keyof typeof DeviceGroupPagingDirectionType
/**
 * Справочник типов направлений сортировки
 */
export type DeviceGroupPagingDirectionTypeRequestEnum = Exclude<DeviceGroupPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов сортировки
 */
export enum DeviceGroupPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По Идентификатору группы пользователя
   */
  GROUP_ID = "GROUP_ID",
  /**
   * По ПУ
   */
  DEVICE_ID = "DEVICE_ID",
}
/**
 * Справочник типов сортировки
 */
export type DeviceGroupPagingOrderByTypeResponseEnum = keyof typeof DeviceGroupPagingOrderByType
/**
 * Справочник типов сортировки
 */
export type DeviceGroupPagingOrderByTypeRequestEnum = Exclude<DeviceGroupPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки
 */
export enum DeviceIndicatorMetricPointPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки
 */
export type DeviceIndicatorMetricPointPagingDirectionTypeResponseEnum = keyof typeof DeviceIndicatorMetricPointPagingDirectionType
/**
 * Справочник типов направлений сортировки
 */
export type DeviceIndicatorMetricPointPagingDirectionTypeRequestEnum = Exclude<DeviceIndicatorMetricPointPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов сортировки
 */
export enum DeviceIndicatorMetricPointPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По Идентификатору индикатора
   */
  INDICATOR_ID = "INDICATOR_ID",
  /**
   * По По Идентификатору ТУ
   */
  METRIC_POINT_ID = "METRIC_POINT_ID",
}
/**
 * Справочник типов сортировки
 */
export type DeviceIndicatorMetricPointPagingOrderByTypeResponseEnum = keyof typeof DeviceIndicatorMetricPointPagingOrderByType
/**
 * Справочник типов сортировки
 */
export type DeviceIndicatorMetricPointPagingOrderByTypeRequestEnum = Exclude<DeviceIndicatorMetricPointPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки
 */
export enum DevicePagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки
 */
export type DevicePagingDirectionTypeResponseEnum = keyof typeof DevicePagingDirectionType
/**
 * Справочник типов направлений сортировки
 */
export type DevicePagingDirectionTypeRequestEnum = Exclude<DevicePagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки
 */
export enum DevicePagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По идентификатору
   */
  ID = "ID",
}
/**
 * Справочник типов значений сортировки
 */
export type DevicePagingOrderByTypeResponseEnum = keyof typeof DevicePagingOrderByType
/**
 * Справочник типов значений сортировки
 */
export type DevicePagingOrderByTypeRequestEnum = Exclude<DevicePagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Справочник типа архивности показаний.
 * Используется для указания за какой период произошло измерение.
 * По умолчанию CURRENT
 */
export enum IndicatorArchiveType {
  /**
   * Значение не указано
   */
  ARCHIVE_TYPE_UNKNOWN = "ARCHIVE_TYPE_UNKNOWN",
  /**
   * Текущие показания
   */
  CURRENT = "CURRENT",
  /**
   * За 30 мин
   */
  HALFHOUR = "HALFHOUR",
  /**
   * За час
   */
  HOUR = "HOUR",
  /**
   * За сутки
   */
  DAY = "DAY",
  /**
   * За месяц
   */
  MONTH = "MONTH",
  /**
   * За год
   */
  YEAR = "YEAR",
}
/**
 * Справочник типа архивности показаний.
 * Используется для указания за какой период произошло измерение.
 * По умолчанию CURRENT
 */
export type IndicatorArchiveTypeResponseEnum = keyof typeof IndicatorArchiveType
/**
 * Справочник типа архивности показаний.
 * Используется для указания за какой период произошло измерение.
 * По умолчанию CURRENT
 */
export type IndicatorArchiveTypeRequestEnum = Exclude<IndicatorArchiveTypeResponseEnum, "ARCHIVE_TYPE_UNKNOWN">;

/**
 * Справочник типов измерений
 */
export enum IndicatorSignType {
  /**
   * Значение не указано
   */
  SIGN_TYPE_UNKNOWN = "SIGN_TYPE_UNKNOWN",
  /**
   * Абсолютный показатель
   */
  ABSOLUTE_DS = "ABSOLUTE_DS",
  /**
   * Абсолютный расход ресурса
   */
  ABSOLUTE_RC = "ABSOLUTE_RC",
  /**
   * Интервальный показатель состояния
   */
  INTERVAL_DS = "INTERVAL_DS",
  /**
   * Интервальный расход ресурса
   */
  INTERVAL_RC = "INTERVAL_RC",
  /**
   * Текущее состояние
   */
  CURRENT_DS = "CURRENT_DS",
  /**
   * Текущее состояние ресурса
   */
  CURRENT_RS = "CURRENT_RS",
  /**
   * Объём
   */
  VOLUME = "VOLUME",
  /**
   * Параметр конфигурации
   */
  PARAMETER = "PARAMETER",
  /**
   * Флаг состояния
   */
  FLAG = "FLAG",
}
/**
 * Справочник типов измерений
 */
export type IndicatorSignTypeResponseEnum = keyof typeof IndicatorSignType
/**
 * Справочник типов измерений
 */
export type IndicatorSignTypeRequestEnum = Exclude<IndicatorSignTypeResponseEnum, "SIGN_TYPE_UNKNOWN">;

/**
 * Справочник типов единиц измерений
 */
export enum IndicatorUnitType {
  /**
   * Значение не указано
   */
  UNIT_TYPE_UNKNOWN = "UNIT_TYPE_UNKNOWN",
  /**
   * Процент
   */
  PERCENT = "PERCENT",
  /**
   * Градус по Цельсию
   */
  C = "C",
  /**
   * Ватт
   */
  WT = "WT",
  /**
   * Гигакалория
   */
  GKAL = "GKAL",
  /**
   * Количество
   */
  VALUE = "VALUE",
  /**
   * Киловaтт-час
   */
  KWH = "KWH",
  /**
   * Килограмм на квадратный сантиметр
   */
  KG_CM2 = "KG_CM2",
  /**
   * Килограмм-сила на квадратный сантиметр
   */
  KGF_CM2 = "KGF_CM2",
  /**
   * Кубический метр
   */
  M3 = "M3",
  /**
   * Кубический метр в час
   */
  M3_H = "M3_H",
  /**
   * Мегапаскаль
   */
  MPA = "MPA",
  /**
   * Миллисекунда
   */
  MS = "MS",
  /**
   * Флаг состояния
   */
  BOOLEAN = "BOOLEAN",
  /**
   * Тонна
   */
  T = "T",
  /**
   * Тонна в час
   */
  T_H = "T_H",
  /**
   * Час
   */
  H = "H",
  /**
   * Безразмерная величина
   */
  NON_MEASURABLE = "NON_MEASURABLE",
  /**
   * Импульс
   */
  IMP = "IMP",
  /**
   * Джоуль
   */
  J = "J",
  /**
   * Килоджоуль
   */
  KJ = "KJ",
  /**
   * Гигаджоуль
   */
  GJ = "GJ",
  /**
   * Ватт-час
   */
  WTH = "WTH",
  /**
   * Киловатт
   */
  KWT = "KWT",
  /**
   * Минута
   */
  MIN = "MIN",
  /**
   * Секунда
   */
  S = "S",
}
/**
 * Справочник типов единиц измерений
 */
export type IndicatorUnitTypeResponseEnum = keyof typeof IndicatorUnitType
/**
 * Справочник типов единиц измерений
 */
export type IndicatorUnitTypeRequestEnum = Exclude<IndicatorUnitTypeResponseEnum, "UNIT_TYPE_UNKNOWN">;

/**
 * Посредники получения показаний
 */
export enum IndicatorVendorType {
  /**
   * Значение не указано
   */
  VENDOR_TYPE_UNKNOWN = "VENDOR_TYPE_UNKNOWN",
  /**
   * Энвайро
   */
  ENVIRO = "ENVIRO",
  /**
   * Лартех
   */
  LARTECH = "LARTECH",
  /**
   * РТК
   */
  RTK = "RTK",
}
/**
 * Посредники получения показаний
 */
export type IndicatorVendorTypeResponseEnum = keyof typeof IndicatorVendorType
/**
 * Посредники получения показаний
 */
export type IndicatorVendorTypeRequestEnum = Exclude<IndicatorVendorTypeResponseEnum, "VENDOR_TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки
 */
export enum IndicatorPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки
 */
export type IndicatorPagingDirectionTypeResponseEnum = keyof typeof IndicatorPagingDirectionType
/**
 * Справочник типов направлений сортировки
 */
export type IndicatorPagingDirectionTypeRequestEnum = Exclude<IndicatorPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов сортировки
 */
export enum IndicatorPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По уникальному ключу
   */
  ID = "ID",
  /**
   * По типу измерений
   */
  SIGN_TYPE = "SIGN_TYPE",
  /**
   * По Прибору учета
   */
  DEVICE_ID = "DEVICE_ID",
  /**
   * По Дате создания
   */
  CREATED_AT = "CREATED_AT",
}
/**
 * Справочник типов сортировки
 */
export type IndicatorPagingOrderByTypeResponseEnum = keyof typeof IndicatorPagingOrderByType
/**
 * Справочник типов сортировки
 */
export type IndicatorPagingOrderByTypeRequestEnum = Exclude<IndicatorPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Запрос удаления индикатора
 */
export type DeleteDeviceIndicatorRequestDto = {
  /**
   * Идентификатор
   */
  id: number
}
/**
 * Ответ на запрос удаления индикатора
 */
export type DeleteDeviceIndicatorResponseDto = {
}
/**
 * Запрос удаления прибора учета
 */
export type DeleteDeviceRequestDto = {
  /**
   * Идентификатор
   */
  id: number
}
/**
 * Ответ на запрос удаления прибора учета
 */
export type DeleteDeviceResponseDto = {
}
/**
 * Прибор учёта
 */
export type DeviceRequestDto = {
  /**
   * Идентификатор
   */
  id?: number
  /**
   * Точка учета
   * @deprecated
   */
  metricPoint?: DeviceMetricPointRequestDto | null
  /**
   * Тип прибора учёта(ПУ)
   */
  type: DeviceTypeRequestEnum
  /**
   * Серийный номер
   */
  serialNumber: string
  /**
   * Производитель и модель счетчика
   */
  model: string
  /**
   * Год выпуска счётчика
   * @deprecated
   */
  year: number
  /**
   * Идентификатор строения ФИАС
   * @deprecated
   */
  fiasId: string
  /**
   * Тип статуса
   */
  statusType?: DeviceStatusTypeRequestEnum | "STATUS_TYPE_UNKNOWN"
  /**
   * Дата установки
   */
  installedAt?: string | null
  /**
   * Дата удаления
   */
  removedAt?: string | null
  /**
   * Дата предыдущей поверки счетчика
   */
  checkAt?: string | null
  /**
   * Дата следующей поверки счетчика
   */
  nextCheckAt?: string | null
  /**
   * Внешний дентификатор прибора учёта(ПУ)
   */
  externalId?: string | null
  /**
   * Тип тарифного плана
   */
  planType?: DevicePlanTypeRequestEnum | "PLAN_TYPE_UNKNOWN"
  /**
   * Идентификатор хаба
   */
  parentId?: number | null
  /**
   * Тип трубопровода
   */
  pipeType?: DevicePipeTypeRequestEnum | "PIPE_TYPE_UNKNOWN"
  /**
   * Идентификатор модуля LoraWan
   */
  devEui?: string | null
  /**
   * MAC-адрес
   */
  mac?: string | null
  /**
   * Номер порта
   */
  port?: number | null
  /**
   * Сетевой адрес
   */
  networkAddress?: string | null
  /**
   * Канал связи.
   * Для станции LoraWan
   */
  commChannel?: string | null
  /**
   * MSISDN SIM-карты.
   * Номер телефона
   */
  simNumber?: string | null
  /**
   * Серийный номер SIM-карты
   */
  simSerial?: string | null
  /**
   * IP адрес SIM-карты
   */
  ipAddressSim?: string | null
  /**
   * Размещение
   */
  placement?: string | null
  /**
   * Место установки
   */
  installationPlace?: string | null
  /**
   * Kлюч приложения.
   * Используется в процессе присоединения к сети для получения сессионных ключей NwkSKey и AppSKey для LoRaWAN [128 бит]
   * @deprecated
   */
  appkey?: string | null
  /**
   * Идентификатор приложения.
   * Для LoRaWAN [64 бита]
   * @deprecated
   */
  appeui?: string | null
  /**
   * Тип протокола
   */
  protocolTypeLabel?: string | null
  /**
   * Номер канала для многоканального ПУ
   * @deprecated
   */
  channelNumber?: number | null
  /**
   * Тип проводного интерфейса
   */
  wireInterface?: string | null
  /**
   * Идентификатор объекта строительства
   */
  buildingId?: number
  /**
   * Год выпуска счётчика
   */
  manufactureYear?: number | null
  /**
   * Посредник получения показаний
   */
  indicatorVendorType?: IndicatorVendorTypeRequestEnum | "VENDOR_TYPE_UNKNOWN"
}
/**
 * Прибор учёта
 */
export type DeviceResponseDto = {
  /**
   * Идентификатор
   */
  id: number
  /**
   * Индикаторы
   */
  readonly indicators: IndicatorResponseDto[]
  /**
   * Точка учета
   * @deprecated
   */
  metricPoint: DeviceMetricPointResponseDto | null
  /**
   * Дата создания
   */
  readonly createdAt: string
  /**
   * Дата последнего изменения.
   * Заполняется и обновляется сервером.
   * Заполняется при создании и изменении.
   * Является версией объекта
   */
  readonly changedAt: string
  /**
   * Тип прибора учёта(ПУ)
   */
  type: DeviceTypeResponseEnum
  /**
   * Серийный номер
   */
  serialNumber: string
  /**
   * Производитель и модель счетчика
   */
  model: string
  /**
   * Год выпуска счётчика
   * @deprecated
   */
  year: number
  /**
   * Идентификатор строения ФИАС
   * @deprecated
   */
  fiasId: string
  /**
   * Идентификатор владельца.
   * Заполняется сервером
   * @deprecated
   */
  readonly resourceOwnerId: string
  /**
   * Тип статуса
   */
  statusType: DeviceStatusTypeResponseEnum
  /**
   * Дата установки
   */
  installedAt: string | null
  /**
   * Дата удаления
   */
  removedAt: string | null
  /**
   * Дата предыдущей поверки счетчика
   */
  checkAt: string | null
  /**
   * Дата следующей поверки счетчика
   */
  nextCheckAt: string | null
  /**
   * Внешний дентификатор прибора учёта(ПУ)
   */
  externalId: string | null
  /**
   * Тип тарифного плана
   */
  planType: DevicePlanTypeResponseEnum
  /**
   * Идентификатор хаба
   */
  parentId: number | null
  /**
   * Тип трубопровода
   */
  pipeType: DevicePipeTypeResponseEnum
  /**
   * Идентификатор модуля LoraWan
   */
  devEui: string | null
  /**
   * MAC-адрес
   */
  mac: string | null
  /**
   * Номер порта
   */
  port: number | null
  /**
   * Сетевой адрес
   */
  networkAddress: string | null
  /**
   * Канал связи.
   * Для станции LoraWan
   */
  commChannel: string | null
  /**
   * MSISDN SIM-карты.
   * Номер телефона
   */
  simNumber: string | null
  /**
   * Серийный номер SIM-карты
   */
  simSerial: string | null
  /**
   * IP адрес SIM-карты
   */
  ipAddressSim: string | null
  /**
   * Размещение
   */
  placement: string | null
  /**
   * Место установки
   */
  installationPlace: string | null
  /**
   * Kлюч приложения.
   * Используется в процессе присоединения к сети для получения сессионных ключей NwkSKey и AppSKey для LoRaWAN [128 бит]
   * @deprecated
   */
  appkey: string | null
  /**
   * Идентификатор приложения.
   * Для LoRaWAN [64 бита]
   * @deprecated
   */
  appeui: string | null
  /**
   * Тип протокола
   */
  protocolTypeLabel: string | null
  /**
   * Номер канала для многоканального ПУ
   * @deprecated
   */
  channelNumber: number | null
  /**
   * Тип проводного интерфейса
   */
  wireInterface: string | null
  /**
   * Идентификатор объекта строительства
   */
  buildingId: number
  /**
   * Год выпуска счётчика
   */
  manufactureYear: number | null
  /**
   * Посредник получения показаний
   */
  indicatorVendorType: IndicatorVendorTypeResponseEnum
}
/**
 * Точка учета
 */
export type DeviceMetricPointRequestDto = {
  /**
   * Идентификатор
   */
  id?: string
  /**
   * Тип энергоресурса
   */
  metricType: DeviceMetricPointMetricTypeRequestEnum
  /**
   * Номер помещения
   */
  roomNumber: string
  /**
   * Лейбл помещения
   */
  roomLabel: string
  /**
   * Зона
   */
  zoneLabel?: string | null
  /**
   * Тип статуса
   */
  statusType: DeviceMetricPointStatusTypeRequestEnum
  /**
   * Тип учёта
   */
  accountingType: DeviceMetricPointAccountingTypeRequestEnum
  /**
   * Тип номинала первичного тока
   */
  primaryCurrentType?: DeviceMetricPointPrimaryCurrentTypeRequestEnum | "PRIMARY_CURRENT_TYPE_UNKNOWN"
  /**
   * Тип номинала вторичной обмотки
   */
  secondaryCurrentType?: DeviceSecondaryCurrentTypeRequestEnum | "SECONDARY_CURRENT_TYPE_UNKNOWN"
  /**
   * Идентификатор объекта строительства
   */
  buildingId: number
  /**
   * Уровень
   */
  buildingLevel?: number
  /**
   * Секция
   */
  buildingSection?: number
}
/**
 * Точка учета
 */
export type DeviceMetricPointResponseDto = {
  /**
   * Идентификатор
   */
  id: string
  /**
   * Тип энергоресурса
   */
  metricType: DeviceMetricPointMetricTypeResponseEnum
  /**
   * Номер помещения
   */
  roomNumber: string
  /**
   * Лейбл помещения
   */
  roomLabel: string
  /**
   * Зона
   */
  zoneLabel: string | null
  /**
   * Тип статуса
   */
  statusType: DeviceMetricPointStatusTypeResponseEnum
  /**
   * Тип учёта
   */
  accountingType: DeviceMetricPointAccountingTypeResponseEnum
  /**
   * Дата создания
   */
  readonly createdAt: string
  /**
   * Тип номинала первичного тока
   */
  primaryCurrentType: DeviceMetricPointPrimaryCurrentTypeResponseEnum
  /**
   * Тип номинала вторичной обмотки
   */
  secondaryCurrentType: DeviceSecondaryCurrentTypeResponseEnum
  /**
   * Идентификатор объекта строительства
   */
  buildingId: number
  /**
   * Дата изменения
   */
  readonly changedAt: string
  /**
   * Уровень
   */
  buildingLevel: number
  /**
   * Секция
   */
  buildingSection: number
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type DeviceValidationErrorRequestDto = {
  /**
   * Путь к полю в формате наименования protobuf
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type DeviceValidationErrorResponseDto = {
  /**
   * Путь к полю в формате наименования protobuf
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Фильтр для запроса приборов учета.
 * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
 * При передаче нескольких разных параметров фильтра они работают в выборке через И
 */
export type DeviceFilterRequestDto = {
  /**
   * По ФИАС
   */
  fiasIds?: string[]
  /**
   * По типам приборов учета
   */
  types?: DeviceTypeResponseEnum[]
  /**
   * По типам статусов
   */
  statusTypes?: DeviceStatusTypeResponseEnum[]
  /**
   * По модели счетчика
   */
  models?: string[]
  /**
   * По типам метрик
   */
  metricPointMetricTypes?: DeviceMetricPointMetricTypeResponseEnum[]
  /**
   * По номерам помещений точек учета, привязанных через индикаторы
   */
  roomNumbers?: string[]
  /**
   * По лейблам помещений точек учета, привязанных через индикаторы
   */
  roomLabels?: string[]
  /**
   * По идентификаторам хабов
   */
  parentIds?: number[]
  /**
   * По идентификаторам приборов учета.
   * Устарело, использовать метод GetDevice
   * @deprecated
   */
  ids?: number[]
  /**
   * По идентификатору объекта строительства
   */
  buildingIds?: number[]
  /**
   * По серийным номерам
   */
  serialNumbers?: string[]
  /**
   * По ID точек учета, привязанных через индикаторы
   */
  metricPointIds?: string[]
  /**
   * Смешанный поиск по полям serial_number, dev_eui, MAC-адрес, model, external_id
   */
  serialIds?: string[]
  /**
   * По ОРПОНам
   */
  orpons?: string[]
  /**
   * По посреднику получения показаний
   */
  indicatorVendorTypes?: IndicatorVendorTypeResponseEnum[]
}
/**
 * Фильтр для запроса приборов учета.
 * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
 * При передаче нескольких разных параметров фильтра они работают в выборке через И
 */
export type DeviceFilterResponseDto = {
  /**
   * По ФИАС
   */
  fiasIds: string[]
  /**
   * По типам приборов учета
   */
  types: DeviceTypeResponseEnum[]
  /**
   * По типам статусов
   */
  statusTypes: DeviceStatusTypeResponseEnum[]
  /**
   * По модели счетчика
   */
  models: string[]
  /**
   * По типам метрик
   */
  metricPointMetricTypes: DeviceMetricPointMetricTypeResponseEnum[]
  /**
   * По номерам помещений точек учета, привязанных через индикаторы
   */
  roomNumbers: string[]
  /**
   * По лейблам помещений точек учета, привязанных через индикаторы
   */
  roomLabels: string[]
  /**
   * По идентификаторам хабов
   */
  parentIds: number[]
  /**
   * По идентификаторам приборов учета.
   * Устарело, использовать метод GetDevice
   * @deprecated
   */
  ids: number[]
  /**
   * По идентификатору объекта строительства
   */
  buildingIds: number[]
  /**
   * По серийным номерам
   */
  serialNumbers: string[]
  /**
   * По ID точек учета, привязанных через индикаторы
   */
  metricPointIds: string[]
  /**
   * Смешанный поиск по полям serial_number, dev_eui, MAC-адрес, model, external_id
   */
  serialIds: string[]
  /**
   * По ОРПОНам
   */
  orpons: string[]
  /**
   * По посреднику получения показаний
   */
  indicatorVendorTypes: IndicatorVendorTypeResponseEnum[]
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type DeviceFilterValidationErrorRequestDto = {
  /**
   * Путь к полю в формате наименования protobuf
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type DeviceFilterValidationErrorResponseDto = {
  /**
   * Путь к полю в формате наименования protobuf
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Связка ПУ и группы пользователя.
 * Задает область ресурсов (resource scope), доступную пользователю.
 * Используется для контроля доступа к ПУ
 */
export type DeviceGroupRequestDto = {
  /**
   * Идентификатор группы.
   * # Тип: Guid
   */
  groupId: string
  /**
   * Идентификатор ПУ.
   * # Диапазон: 0..2147483647
   */
  deviceId: number
}
/**
 * Связка ПУ и группы пользователя.
 * Задает область ресурсов (resource scope), доступную пользователю.
 * Используется для контроля доступа к ПУ
 */
export type DeviceGroupResponseDto = {
  /**
   * Идентификатор группы.
   * # Тип: Guid
   */
  groupId: string
  /**
   * Идентификатор ПУ.
   * # Диапазон: 0..2147483647
   */
  deviceId: number
}
/**
 * Фильтр для запроса связей ПУ и группы пользователя.
 * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
 * При передаче нескольких разных параметров фильтра они работают в выборке через И
 */
export type DeviceGroupFilterRequestDto = {
  /**
   * По Идентификатору группы пользователя
   */
  groupIds?: string[]
  /**
   * По ПУ
   */
  deviceIds?: number[]
}
/**
 * Фильтр для запроса связей ПУ и группы пользователя.
 * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
 * При передаче нескольких разных параметров фильтра они работают в выборке через И
 */
export type DeviceGroupFilterResponseDto = {
  /**
   * По Идентификатору группы пользователя
   */
  groupIds: string[]
  /**
   * По ПУ
   */
  deviceIds: number[]
}
/**
 * Пагинация связей ПУ и группы пользователя
 */
export type DeviceGroupPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: GROUP_ID
   */
  orderByType?: DeviceGroupPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType?: DeviceGroupPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано), то выставляем значение по умолчанию
   */
  limit?: number
  /**
   * Сдвиг.
   * По умолчанию: 0
   */
  offset?: number
}
/**
 * Пагинация связей ПУ и группы пользователя
 */
export type DeviceGroupPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: GROUP_ID
   */
  orderByType: DeviceGroupPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType: DeviceGroupPagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано), то выставляем значение по умолчанию
   */
  limit: number
  /**
   * Сдвиг.
   * По умолчанию: 0
   */
  offset: number
}
/**
 * Связка индикатора и ТУ
 */
export type DeviceIndicatorMetricPointRequestDto = {
  /**
   * Идентификатор индикатора.
   * # Диапазон: 0..2147483647
   */
  indicatorId: number
  /**
   * Идентификатору ТУ.
   * # Тип: Guid
   */
  metricPointId: string
}
/**
 * Связка индикатора и ТУ
 */
export type DeviceIndicatorMetricPointResponseDto = {
  /**
   * Идентификатор индикатора.
   * # Диапазон: 0..2147483647
   */
  indicatorId: number
  /**
   * Идентификатору ТУ.
   * # Тип: Guid
   */
  metricPointId: string
}
/**
 * Фильтр для запроса индикаторов и ТУ.
 * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
 * При передаче нескольких разных параметров фильтра они работают в выборке через И
 */
export type DeviceIndicatorMetricPointFilterRequestDto = {
  /**
   * По Идентификатору индикатора
   */
  indicatorId?: number[]
  /**
   * По Идентификатору ТУ
   */
  metricPointId?: string[]
}
/**
 * Фильтр для запроса индикаторов и ТУ.
 * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
 * При передаче нескольких разных параметров фильтра они работают в выборке через И
 */
export type DeviceIndicatorMetricPointFilterResponseDto = {
  /**
   * По Идентификатору индикатора
   */
  indicatorId: number[]
  /**
   * По Идентификатору ТУ
   */
  metricPointId: string[]
}
/**
 * Пагинация связей индикаторов и ТУ
 */
export type DeviceIndicatorMetricPointPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: ID
   */
  orderByType?: DeviceIndicatorMetricPointPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType?: DeviceIndicatorMetricPointPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано), то выставляем значение по умолчанию
   */
  limit?: number
  /**
   * Сдвиг.
   * По умолчанию: 0
   */
  offset?: number
}
/**
 * Пагинация связей индикаторов и ТУ
 */
export type DeviceIndicatorMetricPointPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: ID
   */
  orderByType: DeviceIndicatorMetricPointPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType: DeviceIndicatorMetricPointPagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано), то выставляем значение по умолчанию
   */
  limit: number
  /**
   * Сдвиг.
   * По умолчанию: 0
   */
  offset: number
}
/**
 * Пагинация устройств
 */
export type DevicePagingRequestDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: ID
   */
  orderByType?: DevicePagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType?: DevicePagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано), то выставляем значение по умолчанию
   */
  limit?: number
  /**
   * Сдвиг.
   * По умолчанию: 0
   */
  offset?: number
}
/**
 * Пагинация устройств
 */
export type DevicePagingResponseDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: ID
   */
  orderByType: DevicePagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType: DevicePagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано), то выставляем значение по умолчанию
   */
  limit: number
  /**
   * Сдвиг.
   * По умолчанию: 0
   */
  offset: number
}
/**
 * Ошибка валидации постраничной пагинации по ПУ.
 * Эти проверки выполняются до обращения в базу данных
 */
export type DevicePagingValidationErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Количество передано некорректно
   */
  readonly limit: DevicePagingValidationErrorLimitInvalidRequestDto
  /**
   * Сдвиг передан некорректно
   */
  readonly offset: DevicePagingValidationErrorOffsetInvalidRequestDto
}>
/**
 * Ошибка валидации постраничной пагинации по ПУ.
 * Эти проверки выполняются до обращения в базу данных
 */
export type DevicePagingValidationErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Количество передано некорректно
   */
  readonly limit: DevicePagingValidationErrorLimitInvalidResponseDto
  /**
   * Сдвиг передан некорректно
   */
  readonly offset: DevicePagingValidationErrorOffsetInvalidResponseDto
}>
/**
 * Причины:
 * - Значение количества < 0 или > 100
 */
export type DevicePagingValidationErrorLimitInvalidRequestDto = {
}
/**
 * Причины:
 * - Значение количества < 0 или > 100
 */
export type DevicePagingValidationErrorLimitInvalidResponseDto = {
}
/**
 * Причины:
 * - Значение сдвига < 0
 */
export type DevicePagingValidationErrorOffsetInvalidRequestDto = {
}
/**
 * Причины:
 * - Значение сдвига < 0
 */
export type DevicePagingValidationErrorOffsetInvalidResponseDto = {
}
/**
 * Запрос получения количества устройств
 */
export type GetDeviceCountRequestDto = {
  /**
   * Фильтр по устройствам
   */
  filter?: DeviceFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества устройств
 */
export type GetDeviceCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего устройств
   */
  readonly data: number
  /**
   * Ошибка
   */
  readonly error: GetDeviceCountResponseErrorDto
}>
/**
 * Ошибка запроса получения количества устройств
 */
export type GetDeviceCountResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка фильтрации
   */
  readonly deviceFilterValidation: DeviceFilterValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения количества устройств
 */
export type GetDeviceCountResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка фильтрации
   */
  readonly deviceFilterValidation: DeviceFilterValidationErrorResponseDto
}>
/**
 * Запрос получения количества связей ПУ и группы пользователя
 */
export type GetDeviceGroupCountRequestDto = {
  /**
   * Фильтр связей ПУ и группы пользователя
   */
  filter?: DeviceGroupFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества связей ПУ и группы пользователя
 */
export type GetDeviceGroupCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего связей ПУ и группы пользователя
   */
  readonly data: number
}>
/**
 * Запрос получения списка
 */
export type GetDeviceGroupListRequestDto = {
  /**
   * Фильтр связей ПУ и группы пользователя
   */
  filter?: DeviceGroupFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Пагинация
   */
  readonly paging: DeviceGroupPagingRequestDto
}>
/**
 * Ответ на запрос получения списка связей ПУ и группы пользователя
 */
export type GetDeviceGroupListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Связь ПУ и группы пользователя
   */
  readonly data: DeviceGroupResponseDto
}>
/**
 * Запрос получения количества индикаторов
 */
export type GetDeviceIndicatorCountRequestDto = {
  /**
   * Фильтр по индикаторам
   */
  filter?: IndicatorFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества индикаторов
 */
export type GetDeviceIndicatorCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего индикаторов
   */
  readonly data: number
  /**
   * Ошибка
   */
  readonly error: GetDeviceIndicatorCountResponseErrorDto
}>
/**
 * Ошибка запроса получения количества индикаторов
 */
export type GetDeviceIndicatorCountResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка фильтрации
   */
  readonly deviceFilterValidation: IndicatorFilterValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения количества индикаторов
 */
export type GetDeviceIndicatorCountResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка фильтрации
   */
  readonly deviceFilterValidation: IndicatorFilterValidationErrorResponseDto
}>
/**
 * Запрос получения списка
 */
export type GetDeviceIndicatorListRequestDto = {
  /**
   * Фильтр индикаторов
   */
  filter?: IndicatorFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Пагинация по индикаторам
   */
  readonly paging: IndicatorPagingRequestDto
}>
/**
 * Ответ на запрос получения списка индикаторов
 */
export type GetDeviceIndicatorListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Индикатор
   */
  readonly data: IndicatorResponseDto
  /**
   * Ошибка
   */
  readonly error: GetDeviceIndicatorListResponseErrorDto
}>
/**
 * Ошибка запроса получения списка индикаторов
 */
export type GetDeviceIndicatorListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка фильтрации
   */
  readonly deviceFilterValidation: IndicatorFilterValidationErrorRequestDto
  /**
   * Ошибка пагинации  по страницам
   */
  readonly devicePagingValidation: IndicatorPagingValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения списка индикаторов
 */
export type GetDeviceIndicatorListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка фильтрации
   */
  readonly deviceFilterValidation: IndicatorFilterValidationErrorResponseDto
  /**
   * Ошибка пагинации  по страницам
   */
  readonly devicePagingValidation: IndicatorPagingValidationErrorResponseDto
}>
/**
 * Запрос получения количества связей индикаторов и ТУ
 */
export type GetDeviceIndicatorMetricPointCountRequestDto = {
  /**
   * Фильтр связей индикаторов и ТУ
   */
  filter?: DeviceIndicatorMetricPointFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества связей индикаторов и ТУ
 */
export type GetDeviceIndicatorMetricPointCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего связей индикаторов и ТУ
   */
  readonly data: number
}>
/**
 * Запрос получения списка
 */
export type GetDeviceIndicatorMetricPointListRequestDto = {
  /**
   * Фильтр связей индикаторов и ТУ
   */
  filter?: DeviceIndicatorMetricPointFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Пагинация
   */
  readonly paging: DeviceIndicatorMetricPointPagingRequestDto
}>
/**
 * Ответ на запрос получения списка связей индикаторов и ТУ
 */
export type GetDeviceIndicatorMetricPointListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Связь индикатора и ТУ
   */
  readonly data: DeviceIndicatorMetricPointResponseDto
}>
/**
 * Запрос получения индикатора
 */
export type GetDeviceIndicatorRequestDto = {
  /**
   * Идентификатор индикатора
   */
  id: number
}
/**
 * Ответ на запрос получения индикатора
 */
export type GetDeviceIndicatorResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Индикатор
   */
  readonly data: IndicatorResponseDto
}>
/**
 * Запрос получения списка
 */
export type GetDeviceListRequestDto = {
  /**
   * Фильтр
   */
  filter?: DeviceFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Пагинация
   */
  readonly paging: DevicePagingRequestDto
}>
/**
 * Ответ на запрос получения списка приборов учета
 */
export type GetDeviceListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Прибор учета
   */
  readonly data: DeviceResponseDto
  /**
   * Ошибка
   */
  readonly error: GetDeviceListResponseErrorDto
}>
/**
 * Ошибка запроса получения списка приборов учета
 */
export type GetDeviceListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка фильтрации
   */
  readonly deviceFilterValidation: DeviceFilterValidationErrorRequestDto
  /**
   * Ошибка пагинации  по страницам
   */
  readonly devicePagingValidation: DevicePagingValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения списка приборов учета
 */
export type GetDeviceListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка фильтрации
   */
  readonly deviceFilterValidation: DeviceFilterValidationErrorResponseDto
  /**
   * Ошибка пагинации  по страницам
   */
  readonly devicePagingValidation: DevicePagingValidationErrorResponseDto
}>
/**
 * Запрос получения ПУ
 */
export type GetDeviceRequestDto = {
  /**
   * Идентификатор ПУ
   */
  id: number
}
/**
 * Ответ на запрос получения ПУ
 */
export type GetDeviceResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Прибор учета
   */
  readonly data: DeviceResponseDto
}>
/**
 * Индикатор
 */
export type IndicatorRequestDto = {
  /**
   * Идентификатор
   */
  id?: number
  /**
   * Идентификатор прибора учета(ПУ)
   */
  deviceId: number
  /**
   * Название
   */
  title: string
  /**
   * Тип единицы измерения, в которой интерпретировано, получаемое измерение
   */
  unitType: IndicatorUnitTypeRequestEnum
  /**
   * Тип измерения
   */
  signType: IndicatorSignTypeRequestEnum
  /**
   * Флаг видимости индикатора для клиента
   */
  isIndividual?: boolean
  /**
   * Код для совместимости с поставщиком метрик
   */
  compatibilityCode?: string | null
  /**
   * Тип архивности показаний
   */
  archiveType?: IndicatorArchiveTypeRequestEnum | "ARCHIVE_TYPE_UNKNOWN"
  /**
   * Тип единицы измерения для отображения измерения.
   * При UNIT_TYPE_UNKNOWN отображаемые единицы совпадают с единицами источников значений, преобразования единиц не происходит.
   * Применяется после коэффициента
   */
  presentationUnitType?: IndicatorUnitTypeRequestEnum | "UNIT_TYPE_UNKNOWN"
  /**
   * Коэффициент, на который умножается отображаемое значение.
   * Применяется перед преобразованием единиц измерений к presentation_unit_type и после применения поправки
   */
  coefficient?: number | null
  /**
   * Величина поправки к отображаемому значению.
   * Применяется перед применением коэффициента
   */
  shift?: number | null
  /**
   * Количество возвращаемых десятичных знаков при округлении итогового значения.
   * При пустом параметре округления не происходит.
   * Применяется после преобразования единиц измерения
   */
  roundDecimalDigits?: number | null
  /**
   * Ожидаемая частота поступления показаний в днях
   */
  metricExpectedFreq?: number
  /**
   * Номер канала для многоканального ПУ
   */
  channelNumber?: string | null
  /**
   * Порядковый номер канала для многоканального ПУ
   */
  channelOrder?: number | null
  /**
   * Посредник получения показаний
   */
  vendorType?: IndicatorVendorTypeRequestEnum | "VENDOR_TYPE_UNKNOWN"
}
/**
 * Индикатор
 */
export type IndicatorResponseDto = {
  /**
   * Идентификатор
   */
  id: number
  /**
   * Идентификатор прибора учета(ПУ)
   */
  deviceId: number
  /**
   * Название
   */
  title: string
  /**
   * Тип единицы измерения, в которой интерпретировано, получаемое измерение
   */
  unitType: IndicatorUnitTypeResponseEnum
  /**
   * Тип измерения
   */
  signType: IndicatorSignTypeResponseEnum
  /**
   * Дата создания
   */
  readonly createdAt: string
  /**
   * Дата последнего изменения.
   * Заполняется и обновляется сервером.
   * Заполняется при создании и изменении.
   * Является версией объекта
   */
  readonly changedAt: string
  /**
   * Флаг видимости индикатора для клиента
   */
  isIndividual: boolean
  /**
   * Код для совместимости с поставщиком метрик
   */
  compatibilityCode: string | null
  /**
   * Тип архивности показаний
   */
  archiveType: IndicatorArchiveTypeResponseEnum
  /**
   * Тип единицы измерения для отображения измерения.
   * При UNIT_TYPE_UNKNOWN отображаемые единицы совпадают с единицами источников значений, преобразования единиц не происходит.
   * Применяется после коэффициента
   */
  presentationUnitType: IndicatorUnitTypeResponseEnum
  /**
   * Коэффициент, на который умножается отображаемое значение.
   * Применяется перед преобразованием единиц измерений к presentation_unit_type и после применения поправки
   */
  coefficient: number | null
  /**
   * Величина поправки к отображаемому значению.
   * Применяется перед применением коэффициента
   */
  shift: number | null
  /**
   * Количество возвращаемых десятичных знаков при округлении итогового значения.
   * При пустом параметре округления не происходит.
   * Применяется после преобразования единиц измерения
   */
  roundDecimalDigits: number | null
  /**
   * Ожидаемая частота поступления показаний в днях
   */
  metricExpectedFreq: number
  /**
   * Номер канала для многоканального ПУ
   */
  channelNumber: string | null
  /**
   * Порядковый номер канала для многоканального ПУ
   */
  channelOrder: number | null
  /**
   * Посредник получения показаний
   */
  vendorType: IndicatorVendorTypeResponseEnum
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type IndicatorValidationErrorRequestDto = {
  /**
   * Путь к полю в формате наименования protobuf
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type IndicatorValidationErrorResponseDto = {
  /**
   * Путь к полю в формате наименования protobuf
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Фильтр для запроса индикаторов.
 * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
 * При передаче нескольких разных параметров фильтра они работают в выборке через И
 */
export type IndicatorFilterRequestDto = {
  /**
   * По списку приборов учета
   */
  deviceIds?: number[]
  /**
   * По типам измерений
   */
  signTypes?: IndicatorSignTypeResponseEnum[]
  /**
   * По списку ключей индикаторов.
   * Устарело, использовать метод GetDeviceIndicator
   * @deprecated
   */
  ids?: number[]
  /**
   * По серийным номерам привязанных ПУ
   */
  deviceSerialNumbers?: string[]
  /**
   * По идентификаторам объектов строительства, привязанных ТУ
   */
  buildingIds?: number[]
  /**
   * По Номерам помещений, привязанных ТУ
   */
  roomNumbers?: string[]
  /**
   * По Лейблам помещений, привязанных ТУ
   */
  roomLabels?: string[]
  /**
   * По ID привязанных точек учета
   */
  metricPointIds?: string[]
  /**
   * По посреднику получения показаний
   */
  indicatorVendorTypes?: IndicatorVendorTypeResponseEnum[]
}
/**
 * Фильтр для запроса индикаторов.
 * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
 * При передаче нескольких разных параметров фильтра они работают в выборке через И
 */
export type IndicatorFilterResponseDto = {
  /**
   * По списку приборов учета
   */
  deviceIds: number[]
  /**
   * По типам измерений
   */
  signTypes: IndicatorSignTypeResponseEnum[]
  /**
   * По списку ключей индикаторов.
   * Устарело, использовать метод GetDeviceIndicator
   * @deprecated
   */
  ids: number[]
  /**
   * По серийным номерам привязанных ПУ
   */
  deviceSerialNumbers: string[]
  /**
   * По идентификаторам объектов строительства, привязанных ТУ
   */
  buildingIds: number[]
  /**
   * По Номерам помещений, привязанных ТУ
   */
  roomNumbers: string[]
  /**
   * По Лейблам помещений, привязанных ТУ
   */
  roomLabels: string[]
  /**
   * По ID привязанных точек учета
   */
  metricPointIds: string[]
  /**
   * По посреднику получения показаний
   */
  indicatorVendorTypes: IndicatorVendorTypeResponseEnum[]
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type IndicatorFilterValidationErrorRequestDto = {
  /**
   * Путь к полю в формате наименования protobuf
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type IndicatorFilterValidationErrorResponseDto = {
  /**
   * Путь к полю в формате наименования protobuf
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Пагинация индикаторов
 */
export type IndicatorPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: ID
   */
  orderByType?: IndicatorPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType?: IndicatorPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано), то выставляем значение по умолчанию
   */
  limit?: number
  /**
   * Сдвиг.
   * По умолчанию: 0
   */
  offset?: number
}
/**
 * Пагинация индикаторов
 */
export type IndicatorPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: ID
   */
  orderByType: IndicatorPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType: IndicatorPagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано), то выставляем значение по умолчанию
   */
  limit: number
  /**
   * Сдвиг.
   * По умолчанию: 0
   */
  offset: number
}
/**
 * Ошибка валидации постраничной пагинации по индикаторам.
 * Эти проверки выполняются до обращения в базу данных
 */
export type IndicatorPagingValidationErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Количество передано некорректно
   */
  readonly limit: IndicatorPagingValidationErrorLimitInvalidRequestDto
  /**
   * Сдвиг передан некорректно
   */
  readonly offset: IndicatorPagingValidationErrorOffsetInvalidRequestDto
}>
/**
 * Ошибка валидации постраничной пагинации по индикаторам.
 * Эти проверки выполняются до обращения в базу данных
 */
export type IndicatorPagingValidationErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Количество передано некорректно
   */
  readonly limit: IndicatorPagingValidationErrorLimitInvalidResponseDto
  /**
   * Сдвиг передан некорректно
   */
  readonly offset: IndicatorPagingValidationErrorOffsetInvalidResponseDto
}>
/**
 * Причины:
 * - Значение количества < 0 или > 100
 */
export type IndicatorPagingValidationErrorLimitInvalidRequestDto = {
}
/**
 * Причины:
 * - Значение количества < 0 или > 100
 */
export type IndicatorPagingValidationErrorLimitInvalidResponseDto = {
}
/**
 * Причины:
 * - Значение сдвига < 0
 */
export type IndicatorPagingValidationErrorOffsetInvalidRequestDto = {
}
/**
 * Причины:
 * - Значение сдвига < 0
 */
export type IndicatorPagingValidationErrorOffsetInvalidResponseDto = {
}
/**
 * Запрос создания задачи с клиента на сервере
 */
export type PostDeviceFullDuplexRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
}
/**
 * task
 */
& fm.OneOf<{
  /**
   * Результат обработки устройства на клиенте
   */
  readonly postDeviceFullDuplexDeviceAsyncStatus: PostDeviceFullDuplexRequestDeviceAsyncStatusDto
}>
/**
 * Результат обработки устройства на клиенте
 */
export type PostDeviceFullDuplexRequestDeviceAsyncStatusDto = {
  /**
   * Идентификатор ПУ
   */
  deviceId: number
}
/**
 * type
 */
& fm.OptionalOneOf<{
  /**
   * Успех
   */
  readonly data: PostDeviceFullDuplexRequestDeviceAsyncStatusSuccessDto
  /**
   * Ошибка
   */
  readonly error: PostDeviceFullDuplexRequestDeviceAsyncStatusErrorDto
}>
/**
 * Ошибки обработки устройства на клиенте
 */
export type PostDeviceFullDuplexRequestDeviceAsyncStatusErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Неизвестная ошибка
   */
  readonly postDeviceRequestUnknown: PostDeviceFullDuplexRequestDeviceAsyncStatusErrorUnknownErrorDto
  /**
   * Неверный IP
   */
  readonly postDeviceRequestIp: PostDeviceFullDuplexRequestDeviceAsyncStatusErrorIpErrorDto
  /**
   * Неверный порт
   */
  readonly postDeviceRequestPort: PostDeviceFullDuplexRequestDeviceAsyncStatusErrorPortErrorDto
  /**
   * Неверный сетевой адрес
   */
  readonly postDeviceRequestNetworkAddress: PostDeviceFullDuplexRequestDeviceAsyncStatusErrorNetworkAddressErrorDto
}>
/**
 * Ошибки обработки устройства на клиенте
 */
export type PostDeviceFullDuplexRequestDeviceAsyncStatusErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Неизвестная ошибка
   */
  readonly postDeviceRequestUnknown: PostDeviceFullDuplexRequestDeviceAsyncStatusErrorUnknownErrorResponseDto
  /**
   * Неверный IP
   */
  readonly postDeviceRequestIp: PostDeviceFullDuplexRequestDeviceAsyncStatusErrorIpErrorResponseDto
  /**
   * Неверный порт
   */
  readonly postDeviceRequestPort: PostDeviceFullDuplexRequestDeviceAsyncStatusErrorPortErrorResponseDto
  /**
   * Неверный сетевой адрес
   */
  readonly postDeviceRequestNetworkAddress: PostDeviceFullDuplexRequestDeviceAsyncStatusErrorNetworkAddressErrorResponseDto
}>
/**
 * Причины:
 *  - Устройство не найденно на данном IP адресе
 */
export type PostDeviceFullDuplexRequestDeviceAsyncStatusErrorIpErrorDto = {
}
/**
 * Причины:
 *  - Устройство не найденно на данном IP адресе
 */
export type PostDeviceFullDuplexRequestDeviceAsyncStatusErrorIpErrorResponseDto = {
}
/**
 * Причины:
 *  - Неверный сетевой адрес
 */
export type PostDeviceFullDuplexRequestDeviceAsyncStatusErrorNetworkAddressErrorDto = {
}
/**
 * Причины:
 *  - Неверный сетевой адрес
 */
export type PostDeviceFullDuplexRequestDeviceAsyncStatusErrorNetworkAddressErrorResponseDto = {
}
/**
 * Причины:
 *  - Устройство отсутствует на порту
 */
export type PostDeviceFullDuplexRequestDeviceAsyncStatusErrorPortErrorDto = {
}
/**
 * Причины:
 *  - Устройство отсутствует на порту
 */
export type PostDeviceFullDuplexRequestDeviceAsyncStatusErrorPortErrorResponseDto = {
}
/**
 * Неизвестная ошибка на стороне клиента
 */
export type PostDeviceFullDuplexRequestDeviceAsyncStatusErrorUnknownErrorDto = {
  /**
   * Произвольный текст ошибки на стороне клиента.
   * Отправляется в случае если в спецификации нет подходящей ошибки.
   * После анализа таких ошибок в спецификацию добавляется специальный тип под эту ошибку
   */
  message: string
}
/**
 * Неизвестная ошибка на стороне клиента
 */
export type PostDeviceFullDuplexRequestDeviceAsyncStatusErrorUnknownErrorResponseDto = {
  /**
   * Произвольный текст ошибки на стороне клиента.
   * Отправляется в случае если в спецификации нет подходящей ошибки.
   * После анализа таких ошибок в спецификацию добавляется специальный тип под эту ошибку
   */
  message: string
}
/**
 * Команда принята
 */
export type PostDeviceFullDuplexRequestDeviceAsyncStatusSuccessDto = {
}
/**
 * Событие изменения ПУ на сервера
 */
export type PostDeviceFullDuplexResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
}
/**
 * event
 */
& fm.OneOf<{
  /**
   * Измененние ПУ на сервере
   */
  readonly postDevice: PostDeviceResponseDto
}>
/**
 * Запрос сохранения индикатора
 */
export type PostDeviceIndicatorRequestDto = {
  /**
   * Индикатор
   */
  data: IndicatorRequestDto
}
/**
 * Ответ на запрос сохранения индикатора
 */
export type PostDeviceIndicatorResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Индикатор
   */
  readonly data: IndicatorResponseDto
  /**
   * Ошибка
   */
  readonly error: PostDeviceIndicatorResponseErrorDto
}>
/**
 * Ошибка запроса сохранения индикатора
 */
export type PostDeviceIndicatorResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: IndicatorValidationErrorRequestDto
}>
/**
 * Ошибка запроса сохранения индикатора
 */
export type PostDeviceIndicatorResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: IndicatorValidationErrorResponseDto
}>
/**
 * Запрос замены прибора учета
 */
export type PostDeviceReplaceRequestDto = {
  /**
   * Идентификатор заменяемого прибора учета
   */
  replaceDeviceId: number
  /**
   * Создаваемый прибор учета
   */
  device: DeviceRequestDto
}
/**
 * Ответ на замену прибора учета
 */
export type PostDeviceReplaceResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Созданный на замену ПУ
   */
  readonly data: DeviceResponseDto
  /**
   * Ошибка
   */
  readonly error: PostDeviceReplaceResponseErrorDto
}>
/**
 * Ошибка замены ПУ
 */
export type PostDeviceReplaceResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: DeviceValidationErrorRequestDto
  /**
   * Не найден заменяемый ПУ
   */
  readonly replaceDeviceNotFound: PostDeviceReplaceResponseErrorReplaceDeviceNotFoundRequestDto
  /**
   * Не удалось создать индикаторы нового ПУ
   */
  readonly createIndicatorsFail: PostDeviceReplaceResponseErrorCreateIndicatorsFailRequestDto
  /**
   * Попытка замены ПУ, привязанного ко многим ТУ
   */
  readonly multiLinkedMetricPoint: PostDeviceReplaceResponseErrorMultiLinkedMetricPointRequestDto
  /**
   * Заменяющий ПУ не привязан к дому заменяемого ПУ
   */
  readonly wrongBuilding: PostDeviceReplaceResponseErrorWrongBuildingRequestDto
  /**
   * Заменяемый ПУ не привязан к ТУ
   */
  readonly metricPointNotFound: PostDeviceReplaceResponseErrorMetricPointNotFoundRequestDto
}>
/**
 * Ошибка замены ПУ
 */
export type PostDeviceReplaceResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: DeviceValidationErrorResponseDto
  /**
   * Не найден заменяемый ПУ
   */
  readonly replaceDeviceNotFound: PostDeviceReplaceResponseErrorReplaceDeviceNotFoundDto
  /**
   * Не удалось создать индикаторы нового ПУ
   */
  readonly createIndicatorsFail: PostDeviceReplaceResponseErrorCreateIndicatorsFailDto
  /**
   * Попытка замены ПУ, привязанного ко многим ТУ
   */
  readonly multiLinkedMetricPoint: PostDeviceReplaceResponseErrorMultiLinkedMetricPointDto
  /**
   * Заменяющий ПУ не привязан к дому заменяемого ПУ
   */
  readonly wrongBuilding: PostDeviceReplaceResponseErrorWrongBuildingDto
  /**
   * Заменяемый ПУ не привязан к ТУ
   */
  readonly metricPointNotFound: PostDeviceReplaceResponseErrorMetricPointNotFoundDto
}>
/**
 * Не удалось создать индикаторы нового ПУ
 */
export type PostDeviceReplaceResponseErrorCreateIndicatorsFailRequestDto = {
}
/**
 * Не удалось создать индикаторы нового ПУ
 */
export type PostDeviceReplaceResponseErrorCreateIndicatorsFailDto = {
}
/**
 * Заменяемый ПУ не привязан к ТУ
 */
export type PostDeviceReplaceResponseErrorMetricPointNotFoundRequestDto = {
}
/**
 * Заменяемый ПУ не привязан к ТУ
 */
export type PostDeviceReplaceResponseErrorMetricPointNotFoundDto = {
}
/**
 * Попытка замены ПУ, привязанного ко многим ТУ
 */
export type PostDeviceReplaceResponseErrorMultiLinkedMetricPointRequestDto = {
}
/**
 * Попытка замены ПУ, привязанного ко многим ТУ
 */
export type PostDeviceReplaceResponseErrorMultiLinkedMetricPointDto = {
}
/**
 * Не найден заменяемый ПУ
 */
export type PostDeviceReplaceResponseErrorReplaceDeviceNotFoundRequestDto = {
}
/**
 * Не найден заменяемый ПУ
 */
export type PostDeviceReplaceResponseErrorReplaceDeviceNotFoundDto = {
}
/**
 * Заменяющий ПУ не привязан к дому заменяемого ПУ
 */
export type PostDeviceReplaceResponseErrorWrongBuildingRequestDto = {
}
/**
 * Заменяющий ПУ не привязан к дому заменяемого ПУ
 */
export type PostDeviceReplaceResponseErrorWrongBuildingDto = {
}
/**
 * Запрос сохранения ПУ
 */
export type PostDeviceRequestDto = {
  /**
   * Прибор учета
   */
  device: DeviceRequestDto
}
/**
 * Ответ на изменение ПУ на сервере
 */
export type PostDeviceResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * ПУ
   */
  readonly data: DeviceResponseDto
  /**
   * Ошибка
   */
  readonly error: PostDeviceResponseErrorDto
}>
/**
 * Ошибка запроса сохранения ПУ
 */
export type PostDeviceResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: DeviceValidationErrorRequestDto
}>
/**
 * Ошибка запроса сохранения ПУ
 */
export type PostDeviceResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: DeviceValidationErrorResponseDto
}>
/**
 * Запрос сохранения связей ПУ и группы пользователя
 */
export type PutDeviceGroupAttachRequestDto = {
  /**
   * Связь ПУ и группы пользователя
   */
  deviceGroup: DeviceGroupRequestDto
}
/**
 * Ответ на запрос сохранения связи ПУ и группы пользователя
 */
export type PutDeviceGroupAttachResponseDto = {
}
/**
 * Запрос удаления связей ПУ и группы пользователя
 */
export type PutDeviceGroupDetachRequestDto = {
  /**
   * Связь ПУ и группы пользователя
   */
  deviceGroup: DeviceGroupRequestDto
}
/**
 * Ответ на запрос удаления связи ПУ и группы пользователя
 */
export type PutDeviceGroupDetachResponseDto = {
}
/**
 * Запрос сохранения связей индикаторов и ТУ
 */
export type PutDeviceIndicatorMetricPointAttachRequestDto = {
  /**
   * Связь индикатора и ТУ
   */
  deviceIndicatorMetricPoint: DeviceIndicatorMetricPointRequestDto
}
/**
 * Ответ на запрос сохранения связи индикатора и ТУ
 */
export type PutDeviceIndicatorMetricPointAttachResponseDto = {
}
/**
 * Запрос удаления связей индикаторов и ТУ
 */
export type PutDeviceIndicatorMetricPointDetachRequestDto = {
  /**
   * Связь индикатора и ТУ
   */
  deviceIndicatorMetricPoint: DeviceIndicatorMetricPointRequestDto
}
/**
 * Ответ на запрос удаления связи индикатора и ТУ
 */
export type PutDeviceIndicatorMetricPointDetachResponseDto = {
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос удаления индикатора
   */
  "DeleteDeviceIndicatorRequest": {
    "kind": "class",
    "text": "Запрос удаления индикатора",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления индикатора
   */
  "DeleteDeviceIndicatorResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления индикатора",
  },
  /**
   * Запрос удаления прибора учета
   */
  "DeleteDeviceRequest": {
    "kind": "class",
    "text": "Запрос удаления прибора учета",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления прибора учета
   */
  "DeleteDeviceResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления прибора учета",
  },
  /**
   * Прибор учёта
   */
  "Device": {
    "kind": "class",
    "text": "Прибор учёта",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор",
      },
      /**
       * Индикаторы
       */
      "indicators": {
        "type": "Indicator",
        "text": "Индикаторы",
      },
      /**
       * Точка учета
       * @deprecated
       */
      "metricPoint": {
        "type": "Device.MetricPoint",
        "text": "Точка учета",
      },
      /**
       * Дата создания
       */
      "createdAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата создания",
      },
      /**
       * Дата последнего изменения.
       * Заполняется и обновляется сервером.
       * Заполняется при создании и изменении.
       * Является версией объекта
       */
      "changedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата последнего изменения.\nЗаполняется и обновляется сервером.\nЗаполняется при создании и изменении.\nЯвляется версией объекта",
      },
      /**
       * Тип прибора учёта(ПУ)
       */
      "type": {
        "type": "Device.Type",
        "text": "Тип прибора учёта(ПУ)",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Серийный номер
       */
      "serialNumber": {
        "type": "string",
        "text": "Серийный номер",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Производитель и модель счетчика
       */
      "model": {
        "type": "string",
        "text": "Производитель и модель счетчика",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Год выпуска счётчика
       * @deprecated
       */
      "year": {
        "type": "int32",
        "text": "Год выпуска счётчика",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор строения ФИАС
       * @deprecated
       */
      "fiasId": {
        "type": "string",
        "text": "Идентификатор строения ФИАС",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор владельца.
       * Заполняется сервером
       * @deprecated
       */
      "resourceOwnerId": {
        "type": "string",
        "text": "Идентификатор владельца.\nЗаполняется сервером",
      },
      /**
       * Тип статуса
       */
      "statusType": {
        "type": "Device.StatusType",
        "text": "Тип статуса",
      },
      /**
       * Дата установки
       */
      "installedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата установки",
      },
      /**
       * Дата удаления
       */
      "removedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата удаления",
      },
      /**
       * Дата предыдущей поверки счетчика
       */
      "checkAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата предыдущей поверки счетчика",
      },
      /**
       * Дата следующей поверки счетчика
       */
      "nextCheckAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата следующей поверки счетчика",
      },
      /**
       * Внешний дентификатор прибора учёта(ПУ)
       */
      "externalId": {
        "type": "google.protobuf.StringValue",
        "text": "Внешний дентификатор прибора учёта(ПУ)",
      },
      /**
       * Тип тарифного плана
       */
      "planType": {
        "type": "Device.PlanType",
        "text": "Тип тарифного плана",
      },
      /**
       * Идентификатор хаба
       */
      "parentId": {
        "type": "google.protobuf.Int32Value",
        "text": "Идентификатор хаба",
      },
      /**
       * Тип трубопровода
       */
      "pipeType": {
        "type": "Device.PipeType",
        "text": "Тип трубопровода",
      },
      /**
       * Идентификатор модуля LoraWan
       */
      "devEui": {
        "type": "google.protobuf.StringValue",
        "text": "Идентификатор модуля LoraWan",
      },
      /**
       * MAC-адрес
       */
      "mac": {
        "type": "google.protobuf.StringValue",
        "text": "MAC-адрес",
      },
      /**
       * Номер порта
       */
      "port": {
        "type": "google.protobuf.Int32Value",
        "text": "Номер порта",
      },
      /**
       * Сетевой адрес
       */
      "networkAddress": {
        "type": "google.protobuf.StringValue",
        "text": "Сетевой адрес",
      },
      /**
       * Канал связи.
       * Для станции LoraWan
       */
      "commChannel": {
        "type": "google.protobuf.StringValue",
        "text": "Канал связи.\nДля станции LoraWan",
      },
      /**
       * MSISDN SIM-карты.
       * Номер телефона
       */
      "simNumber": {
        "type": "google.protobuf.StringValue",
        "text": "MSISDN SIM-карты.\nНомер телефона",
      },
      /**
       * Серийный номер SIM-карты
       */
      "simSerial": {
        "type": "google.protobuf.StringValue",
        "text": "Серийный номер SIM-карты",
      },
      /**
       * IP адрес SIM-карты
       */
      "ipAddressSim": {
        "type": "google.protobuf.StringValue",
        "text": "IP адрес SIM-карты",
      },
      /**
       * Размещение
       */
      "placement": {
        "type": "google.protobuf.StringValue",
        "text": "Размещение",
      },
      /**
       * Место установки
       */
      "installationPlace": {
        "type": "google.protobuf.StringValue",
        "text": "Место установки",
      },
      /**
       * Kлюч приложения.
       * Используется в процессе присоединения к сети для получения сессионных ключей NwkSKey и AppSKey для LoRaWAN [128 бит]
       * @deprecated
       */
      "appkey": {
        "type": "google.protobuf.StringValue",
        "text": "Kлюч приложения.\nИспользуется в процессе присоединения к сети для получения сессионных ключей NwkSKey и AppSKey для LoRaWAN [128 бит]",
      },
      /**
       * Идентификатор приложения.
       * Для LoRaWAN [64 бита]
       * @deprecated
       */
      "appeui": {
        "type": "google.protobuf.StringValue",
        "text": "Идентификатор приложения.\nДля LoRaWAN [64 бита]",
      },
      /**
       * Тип протокола
       */
      "protocolTypeLabel": {
        "type": "google.protobuf.StringValue",
        "text": "Тип протокола",
      },
      /**
       * Номер канала для многоканального ПУ
       * @deprecated
       */
      "channelNumber": {
        "type": "google.protobuf.Int32Value",
        "text": "Номер канала для многоканального ПУ",
      },
      /**
       * Тип проводного интерфейса
       */
      "wireInterface": {
        "type": "google.protobuf.StringValue",
        "text": "Тип проводного интерфейса",
      },
      /**
       * Идентификатор объекта строительства
       */
      "buildingId": {
        "type": "int32",
        "text": "Идентификатор объекта строительства",
      },
      /**
       * Год выпуска счётчика
       */
      "manufactureYear": {
        "type": "google.protobuf.Int32Value",
        "text": "Год выпуска счётчика",
      },
      /**
       * Посредник получения показаний
       */
      "indicatorVendorType": {
        "type": "Indicator.VendorType",
        "text": "Посредник получения показаний",
      },
    },
  },
  /**
   * Точка учета
   */
  "Device.MetricPoint": {
    "kind": "class",
    "text": "Точка учета",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "string",
        "text": "Идентификатор",
      },
      /**
       * Тип энергоресурса
       */
      "metricType": {
        "type": "Device.MetricPoint.MetricType",
        "text": "Тип энергоресурса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер помещения
       */
      "roomNumber": {
        "type": "string",
        "text": "Номер помещения",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Лейбл помещения
       */
      "roomLabel": {
        "type": "string",
        "text": "Лейбл помещения",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Зона
       */
      "zoneLabel": {
        "type": "google.protobuf.StringValue",
        "text": "Зона",
      },
      /**
       * Тип статуса
       */
      "statusType": {
        "type": "Device.MetricPoint.StatusType",
        "text": "Тип статуса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тип учёта
       */
      "accountingType": {
        "type": "Device.MetricPoint.AccountingType",
        "text": "Тип учёта",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Дата создания
       */
      "createdAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата создания",
      },
      /**
       * Тип номинала первичного тока
       */
      "primaryCurrentType": {
        "type": "Device.MetricPoint.PrimaryCurrentType",
        "text": "Тип номинала первичного тока",
      },
      /**
       * Тип номинала вторичной обмотки
       */
      "secondaryCurrentType": {
        "type": "Device.SecondaryCurrentType",
        "text": "Тип номинала вторичной обмотки",
      },
      /**
       * Идентификатор объекта строительства
       */
      "buildingId": {
        "type": "int32",
        "text": "Идентификатор объекта строительства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Дата изменения
       */
      "changedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата изменения",
      },
      /**
       * Уровень
       */
      "buildingLevel": {
        "type": "int32",
        "text": "Уровень",
      },
      /**
       * Секция
       */
      "buildingSection": {
        "type": "int32",
        "text": "Секция",
      },
    },
  },
  /**
   * Ошибки валидации.
   * Эти проверки выполняются до обращения в базу данных
   */
  "Device.ValidationError": {
    "kind": "class",
    "text": "Ошибки валидации.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Путь к полю в формате наименования protobuf
       */
      "path": {
        "type": "string",
        "text": "Путь к полю в формате наименования protobuf",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Валидационное сообщение
       */
      "message": {
        "type": "string",
        "text": "Валидационное сообщение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Фильтр для запроса приборов учета.
   * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
   * При передаче нескольких разных параметров фильтра они работают в выборке через И
   */
  "DeviceFilter": {
    "kind": "class",
    "text": "Фильтр для запроса приборов учета.\nПри передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.\nПри передаче нескольких разных параметров фильтра они работают в выборке через И",
    "fields": {
      /**
       * По ФИАС
       */
      "fiasIds": {
        "type": "string",
        "text": "По ФИАС",
      },
      /**
       * По типам приборов учета
       */
      "types": {
        "type": "Device.Type",
        "text": "По типам приборов учета",
      },
      /**
       * По типам статусов
       */
      "statusTypes": {
        "type": "Device.StatusType",
        "text": "По типам статусов",
      },
      /**
       * По модели счетчика
       */
      "models": {
        "type": "string",
        "text": "По модели счетчика",
      },
      /**
       * По типам метрик
       */
      "metricPointMetricTypes": {
        "type": "Device.MetricPoint.MetricType",
        "text": "По типам метрик",
      },
      /**
       * По номерам помещений точек учета, привязанных через индикаторы
       */
      "roomNumbers": {
        "type": "string",
        "text": "По номерам помещений точек учета, привязанных через индикаторы",
      },
      /**
       * По лейблам помещений точек учета, привязанных через индикаторы
       */
      "roomLabels": {
        "type": "string",
        "text": "По лейблам помещений точек учета, привязанных через индикаторы",
      },
      /**
       * По идентификаторам хабов
       */
      "parentIds": {
        "type": "int32",
        "text": "По идентификаторам хабов",
      },
      /**
       * По идентификаторам приборов учета.
       * Устарело, использовать метод GetDevice
       * @deprecated
       */
      "ids": {
        "type": "int32",
        "text": "По идентификаторам приборов учета.\nУстарело, использовать метод GetDevice",
      },
      /**
       * По идентификатору объекта строительства
       */
      "buildingIds": {
        "type": "int32",
        "text": "По идентификатору объекта строительства",
      },
      /**
       * По серийным номерам
       */
      "serialNumbers": {
        "type": "string",
        "text": "По серийным номерам",
      },
      /**
       * По ID точек учета, привязанных через индикаторы
       */
      "metricPointIds": {
        "type": "string",
        "text": "По ID точек учета, привязанных через индикаторы",
      },
      /**
       * Смешанный поиск по полям serial_number, dev_eui, MAC-адрес, model, external_id
       */
      "serialIds": {
        "type": "string",
        "text": "Смешанный поиск по полям serial_number, dev_eui, MAC-адрес, model, external_id",
      },
      /**
       * По ОРПОНам
       */
      "orpons": {
        "type": "int64",
        "text": "По ОРПОНам",
      },
      /**
       * По посреднику получения показаний
       */
      "indicatorVendorTypes": {
        "type": "Indicator.VendorType",
        "text": "По посреднику получения показаний",
      },
    },
  },
  /**
   * Ошибки валидации.
   * Эти проверки выполняются до обращения в базу данных
   */
  "DeviceFilter.ValidationError": {
    "kind": "class",
    "text": "Ошибки валидации.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Путь к полю в формате наименования protobuf
       */
      "path": {
        "type": "string",
        "text": "Путь к полю в формате наименования protobuf",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Валидационное сообщение
       */
      "message": {
        "type": "string",
        "text": "Валидационное сообщение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Связка ПУ и группы пользователя.
   * Задает область ресурсов (resource scope), доступную пользователю.
   * Используется для контроля доступа к ПУ
   */
  "DeviceGroup": {
    "kind": "class",
    "text": "Связка ПУ и группы пользователя.\nЗадает область ресурсов (resource scope), доступную пользователю.\nИспользуется для контроля доступа к ПУ",
    "fields": {
      /**
       * Идентификатор группы.
       * # Тип: Guid
       */
      "groupId": {
        "type": "string",
        "text": "Идентификатор группы.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор ПУ.
       * # Диапазон: 0..2147483647
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор ПУ.\n# Диапазон: 0..2147483647",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Фильтр для запроса связей ПУ и группы пользователя.
   * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
   * При передаче нескольких разных параметров фильтра они работают в выборке через И
   */
  "DeviceGroupFilter": {
    "kind": "class",
    "text": "Фильтр для запроса связей ПУ и группы пользователя.\nПри передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.\nПри передаче нескольких разных параметров фильтра они работают в выборке через И",
    "fields": {
      /**
       * По Идентификатору группы пользователя
       */
      "groupIds": {
        "type": "string",
        "text": "По Идентификатору группы пользователя",
      },
      /**
       * По ПУ
       */
      "deviceIds": {
        "type": "int32",
        "text": "По ПУ",
      },
    },
  },
  /**
   * Пагинация связей ПУ и группы пользователя
   */
  "DeviceGroupPaging": {
    "kind": "class",
    "text": "Пагинация связей ПУ и группы пользователя",
    "fields": {
      /**
       * Тип значения сортировки.
       * По умолчанию: GROUP_ID
       */
      "orderByType": {
        "type": "DeviceGroupPaging.OrderByType",
        "text": "Тип значения сортировки.\nПо умолчанию: GROUP_ID",
      },
      /**
       * Тип направления сортировки.
       * По умолчанию: DESC
       */
      "directionType": {
        "type": "DeviceGroupPaging.DirectionType",
        "text": "Тип направления сортировки.\nПо умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Минимальное значение: 1.
       * Максимальное значение: 100.
       * По умолчанию: 20.
       * Если значение 0 (не передано), то выставляем значение по умолчанию
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nМинимальное значение: 1.\nМаксимальное значение: 100.\nПо умолчанию: 20.\nЕсли значение 0 (не передано), то выставляем значение по умолчанию",
      },
      /**
       * Сдвиг.
       * По умолчанию: 0
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\nПо умолчанию: 0",
      },
    },
  },
  /**
   * Связка индикатора и ТУ
   */
  "DeviceIndicatorMetricPoint": {
    "kind": "class",
    "text": "Связка индикатора и ТУ",
    "fields": {
      /**
       * Идентификатор индикатора.
       * # Диапазон: 0..2147483647
       */
      "indicatorId": {
        "type": "int32",
        "text": "Идентификатор индикатора.\n# Диапазон: 0..2147483647",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
      /**
       * Идентификатору ТУ.
       * # Тип: Guid
       */
      "metricPointId": {
        "type": "string",
        "text": "Идентификатору ТУ.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Фильтр для запроса индикаторов и ТУ.
   * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
   * При передаче нескольких разных параметров фильтра они работают в выборке через И
   */
  "DeviceIndicatorMetricPointFilter": {
    "kind": "class",
    "text": "Фильтр для запроса индикаторов и ТУ.\nПри передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.\nПри передаче нескольких разных параметров фильтра они работают в выборке через И",
    "fields": {
      /**
       * По Идентификатору индикатора
       */
      "indicatorId": {
        "type": "int32",
        "text": "По Идентификатору индикатора",
      },
      /**
       * По Идентификатору ТУ
       */
      "metricPointId": {
        "type": "string",
        "text": "По Идентификатору ТУ",
      },
    },
  },
  /**
   * Пагинация связей индикаторов и ТУ
   */
  "DeviceIndicatorMetricPointPaging": {
    "kind": "class",
    "text": "Пагинация связей индикаторов и ТУ",
    "fields": {
      /**
       * Тип значения сортировки.
       * По умолчанию: ID
       */
      "orderByType": {
        "type": "DeviceIndicatorMetricPointPaging.OrderByType",
        "text": "Тип значения сортировки.\nПо умолчанию: ID",
      },
      /**
       * Тип направления сортировки.
       * По умолчанию: DESC
       */
      "directionType": {
        "type": "DeviceIndicatorMetricPointPaging.DirectionType",
        "text": "Тип направления сортировки.\nПо умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Минимальное значение: 1.
       * Максимальное значение: 100.
       * По умолчанию: 20.
       * Если значение 0 (не передано), то выставляем значение по умолчанию
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nМинимальное значение: 1.\nМаксимальное значение: 100.\nПо умолчанию: 20.\nЕсли значение 0 (не передано), то выставляем значение по умолчанию",
      },
      /**
       * Сдвиг.
       * По умолчанию: 0
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\nПо умолчанию: 0",
      },
    },
  },
  /**
   * Пагинация устройств
   */
  "DevicePaging": {
    "kind": "class",
    "text": "Пагинация устройств",
    "fields": {
      /**
       * Тип значения сортировки.
       * По умолчанию: ID
       */
      "orderByType": {
        "type": "DevicePaging.OrderByType",
        "text": "Тип значения сортировки.\nПо умолчанию: ID",
      },
      /**
       * Тип направления сортировки.
       * По умолчанию: DESC
       */
      "directionType": {
        "type": "DevicePaging.DirectionType",
        "text": "Тип направления сортировки.\nПо умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Минимальное значение: 1.
       * Максимальное значение: 100.
       * По умолчанию: 20.
       * Если значение 0 (не передано), то выставляем значение по умолчанию
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nМинимальное значение: 1.\nМаксимальное значение: 100.\nПо умолчанию: 20.\nЕсли значение 0 (не передано), то выставляем значение по умолчанию",
      },
      /**
       * Сдвиг.
       * По умолчанию: 0
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\nПо умолчанию: 0",
      },
    },
  },
  /**
   * Ошибка валидации постраничной пагинации по ПУ.
   * Эти проверки выполняются до обращения в базу данных
   */
  "DevicePaging.ValidationError": {
    "kind": "class",
    "text": "Ошибка валидации постраничной пагинации по ПУ.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Количество передано некорректно
       */
      "limit": {
        "type": "DevicePaging.ValidationError.LimitInvalid",
        "text": "Количество передано некорректно",
      },
      /**
       * Сдвиг передан некорректно
       */
      "offset": {
        "type": "DevicePaging.ValidationError.OffsetInvalid",
        "text": "Сдвиг передан некорректно",
      },
    },
  },
  /**
   * Причины:
   * - Значение количества < 0 или > 100
   */
  "DevicePaging.ValidationError.LimitInvalid": {
    "kind": "class",
    "text": "Причины:\n- Значение количества < 0 или > 100",
  },
  /**
   * Причины:
   * - Значение сдвига < 0
   */
  "DevicePaging.ValidationError.OffsetInvalid": {
    "kind": "class",
    "text": "Причины:\n- Значение сдвига < 0",
  },
  /**
   * Запрос получения количества устройств
   */
  "GetDeviceCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества устройств",
    "fields": {
      /**
       * Фильтр по устройствам
       */
      "filter": {
        "type": "DeviceFilter",
        "text": "Фильтр по устройствам",
      },
    },
  },
  /**
   * Ответ на запрос получения количества устройств
   */
  "GetDeviceCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества устройств",
    "fields": {
      /**
       * Всего устройств
       */
      "data": {
        "type": "int32",
        "text": "Всего устройств",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetDeviceCountResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения количества устройств
   */
  "GetDeviceCountResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения количества устройств",
    "fields": {
      /**
       * Ошибка фильтрации
       */
      "deviceFilterValidation": {
        "type": "DeviceFilter.ValidationError",
        "text": "Ошибка фильтрации",
      },
    },
  },
  /**
   * Запрос получения количества связей ПУ и группы пользователя
   */
  "GetDeviceGroupCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества связей ПУ и группы пользователя",
    "fields": {
      /**
       * Фильтр связей ПУ и группы пользователя
       */
      "filter": {
        "type": "DeviceGroupFilter",
        "text": "Фильтр связей ПУ и группы пользователя",
      },
    },
  },
  /**
   * Ответ на запрос получения количества связей ПУ и группы пользователя
   */
  "GetDeviceGroupCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества связей ПУ и группы пользователя",
    "fields": {
      /**
       * Всего связей ПУ и группы пользователя
       */
      "data": {
        "type": "int32",
        "text": "Всего связей ПУ и группы пользователя",
      },
    },
  },
  /**
   * Запрос получения списка
   */
  "GetDeviceGroupListRequest": {
    "kind": "class",
    "text": "Запрос получения списка",
    "fields": {
      /**
       * Фильтр связей ПУ и группы пользователя
       */
      "filter": {
        "type": "DeviceGroupFilter",
        "text": "Фильтр связей ПУ и группы пользователя",
      },
      /**
       * Пагинация
       */
      "paging": {
        "type": "DeviceGroupPaging",
        "text": "Пагинация",
      },
    },
  },
  /**
   * Ответ на запрос получения списка связей ПУ и группы пользователя
   */
  "GetDeviceGroupListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка связей ПУ и группы пользователя",
    "fields": {
      /**
       * Связь ПУ и группы пользователя
       */
      "data": {
        "type": "DeviceGroup",
        "text": "Связь ПУ и группы пользователя",
      },
    },
  },
  /**
   * Запрос получения количества индикаторов
   */
  "GetDeviceIndicatorCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества индикаторов",
    "fields": {
      /**
       * Фильтр по индикаторам
       */
      "filter": {
        "type": "IndicatorFilter",
        "text": "Фильтр по индикаторам",
      },
    },
  },
  /**
   * Ответ на запрос получения количества индикаторов
   */
  "GetDeviceIndicatorCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества индикаторов",
    "fields": {
      /**
       * Всего индикаторов
       */
      "data": {
        "type": "int32",
        "text": "Всего индикаторов",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetDeviceIndicatorCountResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения количества индикаторов
   */
  "GetDeviceIndicatorCountResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения количества индикаторов",
    "fields": {
      /**
       * Ошибка фильтрации
       */
      "deviceFilterValidation": {
        "type": "IndicatorFilter.ValidationError",
        "text": "Ошибка фильтрации",
      },
    },
  },
  /**
   * Запрос получения списка
   */
  "GetDeviceIndicatorListRequest": {
    "kind": "class",
    "text": "Запрос получения списка",
    "fields": {
      /**
       * Фильтр индикаторов
       */
      "filter": {
        "type": "IndicatorFilter",
        "text": "Фильтр индикаторов",
      },
      /**
       * Пагинация по индикаторам
       */
      "paging": {
        "type": "IndicatorPaging",
        "text": "Пагинация по индикаторам",
      },
    },
  },
  /**
   * Ответ на запрос получения списка индикаторов
   */
  "GetDeviceIndicatorListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка индикаторов",
    "fields": {
      /**
       * Индикатор
       */
      "data": {
        "type": "Indicator",
        "text": "Индикатор",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetDeviceIndicatorListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения списка индикаторов
   */
  "GetDeviceIndicatorListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения списка индикаторов",
    "fields": {
      /**
       * Ошибка фильтрации
       */
      "deviceFilterValidation": {
        "type": "IndicatorFilter.ValidationError",
        "text": "Ошибка фильтрации",
      },
      /**
       * Ошибка пагинации  по страницам
       */
      "devicePagingValidation": {
        "type": "IndicatorPaging.ValidationError",
        "text": "Ошибка пагинации  по страницам",
      },
    },
  },
  /**
   * Запрос получения количества связей индикаторов и ТУ
   */
  "GetDeviceIndicatorMetricPointCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества связей индикаторов и ТУ",
    "fields": {
      /**
       * Фильтр связей индикаторов и ТУ
       */
      "filter": {
        "type": "DeviceIndicatorMetricPointFilter",
        "text": "Фильтр связей индикаторов и ТУ",
      },
    },
  },
  /**
   * Ответ на запрос получения количества связей индикаторов и ТУ
   */
  "GetDeviceIndicatorMetricPointCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества связей индикаторов и ТУ",
    "fields": {
      /**
       * Всего связей индикаторов и ТУ
       */
      "data": {
        "type": "int32",
        "text": "Всего связей индикаторов и ТУ",
      },
    },
  },
  /**
   * Запрос получения списка
   */
  "GetDeviceIndicatorMetricPointListRequest": {
    "kind": "class",
    "text": "Запрос получения списка",
    "fields": {
      /**
       * Фильтр связей индикаторов и ТУ
       */
      "filter": {
        "type": "DeviceIndicatorMetricPointFilter",
        "text": "Фильтр связей индикаторов и ТУ",
      },
      /**
       * Пагинация
       */
      "paging": {
        "type": "DeviceIndicatorMetricPointPaging",
        "text": "Пагинация",
      },
    },
  },
  /**
   * Ответ на запрос получения списка связей индикаторов и ТУ
   */
  "GetDeviceIndicatorMetricPointListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка связей индикаторов и ТУ",
    "fields": {
      /**
       * Связь индикатора и ТУ
       */
      "data": {
        "type": "DeviceIndicatorMetricPoint",
        "text": "Связь индикатора и ТУ",
      },
    },
  },
  /**
   * Запрос получения индикатора
   */
  "GetDeviceIndicatorRequest": {
    "kind": "class",
    "text": "Запрос получения индикатора",
    "fields": {
      /**
       * Идентификатор индикатора
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор индикатора",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения индикатора
   */
  "GetDeviceIndicatorResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения индикатора",
    "fields": {
      /**
       * Индикатор
       */
      "data": {
        "type": "Indicator",
        "text": "Индикатор",
      },
    },
  },
  /**
   * Запрос получения списка
   */
  "GetDeviceListRequest": {
    "kind": "class",
    "text": "Запрос получения списка",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "DeviceFilter",
        "text": "Фильтр",
      },
      /**
       * Пагинация
       */
      "paging": {
        "type": "DevicePaging",
        "text": "Пагинация",
      },
    },
  },
  /**
   * Ответ на запрос получения списка приборов учета
   */
  "GetDeviceListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка приборов учета",
    "fields": {
      /**
       * Прибор учета
       */
      "data": {
        "type": "Device",
        "text": "Прибор учета",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetDeviceListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения списка приборов учета
   */
  "GetDeviceListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения списка приборов учета",
    "fields": {
      /**
       * Ошибка фильтрации
       */
      "deviceFilterValidation": {
        "type": "DeviceFilter.ValidationError",
        "text": "Ошибка фильтрации",
      },
      /**
       * Ошибка пагинации  по страницам
       */
      "devicePagingValidation": {
        "type": "DevicePaging.ValidationError",
        "text": "Ошибка пагинации  по страницам",
      },
    },
  },
  /**
   * Запрос получения ПУ
   */
  "GetDeviceRequest": {
    "kind": "class",
    "text": "Запрос получения ПУ",
    "fields": {
      /**
       * Идентификатор ПУ
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор ПУ",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения ПУ
   */
  "GetDeviceResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения ПУ",
    "fields": {
      /**
       * Прибор учета
       */
      "data": {
        "type": "Device",
        "text": "Прибор учета",
      },
    },
  },
  /**
   * Индикатор
   */
  "Indicator": {
    "kind": "class",
    "text": "Индикатор",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор",
      },
      /**
       * Идентификатор прибора учета(ПУ)
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор прибора учета(ПУ)",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Название
       */
      "title": {
        "type": "string",
        "text": "Название",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тип единицы измерения, в которой интерпретировано, получаемое измерение
       */
      "unitType": {
        "type": "Indicator.UnitType",
        "text": "Тип единицы измерения, в которой интерпретировано, получаемое измерение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тип измерения
       */
      "signType": {
        "type": "Indicator.SignType",
        "text": "Тип измерения",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Дата создания
       */
      "createdAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата создания",
      },
      /**
       * Дата последнего изменения.
       * Заполняется и обновляется сервером.
       * Заполняется при создании и изменении.
       * Является версией объекта
       */
      "changedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата последнего изменения.\nЗаполняется и обновляется сервером.\nЗаполняется при создании и изменении.\nЯвляется версией объекта",
      },
      /**
       * Флаг видимости индикатора для клиента
       */
      "isIndividual": {
        "type": "bool",
        "text": "Флаг видимости индикатора для клиента",
      },
      /**
       * Код для совместимости с поставщиком метрик
       */
      "compatibilityCode": {
        "type": "google.protobuf.StringValue",
        "text": "Код для совместимости с поставщиком метрик",
      },
      /**
       * Тип архивности показаний
       */
      "archiveType": {
        "type": "Indicator.ArchiveType",
        "text": "Тип архивности показаний",
      },
      /**
       * Тип единицы измерения для отображения измерения.
       * При UNIT_TYPE_UNKNOWN отображаемые единицы совпадают с единицами источников значений, преобразования единиц не происходит.
       * Применяется после коэффициента
       */
      "presentationUnitType": {
        "type": "Indicator.UnitType",
        "text": "Тип единицы измерения для отображения измерения.\nПри UNIT_TYPE_UNKNOWN отображаемые единицы совпадают с единицами источников значений, преобразования единиц не происходит.\nПрименяется после коэффициента",
      },
      /**
       * Коэффициент, на который умножается отображаемое значение.
       * Применяется перед преобразованием единиц измерений к presentation_unit_type и после применения поправки
       */
      "coefficient": {
        "type": "google.protobuf.FloatValue",
        "text": "Коэффициент, на который умножается отображаемое значение.\nПрименяется перед преобразованием единиц измерений к presentation_unit_type и после применения поправки",
      },
      /**
       * Величина поправки к отображаемому значению.
       * Применяется перед применением коэффициента
       */
      "shift": {
        "type": "google.protobuf.FloatValue",
        "text": "Величина поправки к отображаемому значению.\nПрименяется перед применением коэффициента",
      },
      /**
       * Количество возвращаемых десятичных знаков при округлении итогового значения.
       * При пустом параметре округления не происходит.
       * Применяется после преобразования единиц измерения
       */
      "roundDecimalDigits": {
        "type": "google.protobuf.Int32Value",
        "text": "Количество возвращаемых десятичных знаков при округлении итогового значения.\nПри пустом параметре округления не происходит.\nПрименяется после преобразования единиц измерения",
      },
      /**
       * Ожидаемая частота поступления показаний в днях
       */
      "metricExpectedFreq": {
        "type": "int32",
        "text": "Ожидаемая частота поступления показаний в днях",
      },
      /**
       * Номер канала для многоканального ПУ
       */
      "channelNumber": {
        "type": "google.protobuf.StringValue",
        "text": "Номер канала для многоканального ПУ",
      },
      /**
       * Порядковый номер канала для многоканального ПУ
       */
      "channelOrder": {
        "type": "google.protobuf.Int32Value",
        "text": "Порядковый номер канала для многоканального ПУ",
      },
      /**
       * Посредник получения показаний
       */
      "vendorType": {
        "type": "Indicator.VendorType",
        "text": "Посредник получения показаний",
      },
    },
  },
  /**
   * Ошибки валидации.
   * Эти проверки выполняются до обращения в базу данных
   */
  "Indicator.ValidationError": {
    "kind": "class",
    "text": "Ошибки валидации.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Путь к полю в формате наименования protobuf
       */
      "path": {
        "type": "string",
        "text": "Путь к полю в формате наименования protobuf",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Валидационное сообщение
       */
      "message": {
        "type": "string",
        "text": "Валидационное сообщение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Фильтр для запроса индикаторов.
   * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
   * При передаче нескольких разных параметров фильтра они работают в выборке через И
   */
  "IndicatorFilter": {
    "kind": "class",
    "text": "Фильтр для запроса индикаторов.\nПри передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.\nПри передаче нескольких разных параметров фильтра они работают в выборке через И",
    "fields": {
      /**
       * По списку приборов учета
       */
      "deviceIds": {
        "type": "int32",
        "text": "По списку приборов учета",
      },
      /**
       * По типам измерений
       */
      "signTypes": {
        "type": "Indicator.SignType",
        "text": "По типам измерений",
      },
      /**
       * По списку ключей индикаторов.
       * Устарело, использовать метод GetDeviceIndicator
       * @deprecated
       */
      "ids": {
        "type": "int32",
        "text": "По списку ключей индикаторов.\nУстарело, использовать метод GetDeviceIndicator",
      },
      /**
       * По серийным номерам привязанных ПУ
       */
      "deviceSerialNumbers": {
        "type": "string",
        "text": "По серийным номерам привязанных ПУ",
      },
      /**
       * По идентификаторам объектов строительства, привязанных ТУ
       */
      "buildingIds": {
        "type": "int32",
        "text": "По идентификаторам объектов строительства, привязанных ТУ",
      },
      /**
       * По Номерам помещений, привязанных ТУ
       */
      "roomNumbers": {
        "type": "string",
        "text": "По Номерам помещений, привязанных ТУ",
      },
      /**
       * По Лейблам помещений, привязанных ТУ
       */
      "roomLabels": {
        "type": "string",
        "text": "По Лейблам помещений, привязанных ТУ",
      },
      /**
       * По ID привязанных точек учета
       */
      "metricPointIds": {
        "type": "string",
        "text": "По ID привязанных точек учета",
      },
      /**
       * По посреднику получения показаний
       */
      "indicatorVendorTypes": {
        "type": "Indicator.VendorType",
        "text": "По посреднику получения показаний",
      },
    },
  },
  /**
   * Ошибки валидации.
   * Эти проверки выполняются до обращения в базу данных
   */
  "IndicatorFilter.ValidationError": {
    "kind": "class",
    "text": "Ошибки валидации.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Путь к полю в формате наименования protobuf
       */
      "path": {
        "type": "string",
        "text": "Путь к полю в формате наименования protobuf",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Валидационное сообщение
       */
      "message": {
        "type": "string",
        "text": "Валидационное сообщение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Пагинация индикаторов
   */
  "IndicatorPaging": {
    "kind": "class",
    "text": "Пагинация индикаторов",
    "fields": {
      /**
       * Тип значения сортировки.
       * По умолчанию: ID
       */
      "orderByType": {
        "type": "IndicatorPaging.OrderByType",
        "text": "Тип значения сортировки.\nПо умолчанию: ID",
      },
      /**
       * Тип направления сортировки.
       * По умолчанию: DESC
       */
      "directionType": {
        "type": "IndicatorPaging.DirectionType",
        "text": "Тип направления сортировки.\nПо умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Минимальное значение: 1.
       * Максимальное значение: 100.
       * По умолчанию: 20.
       * Если значение 0 (не передано), то выставляем значение по умолчанию
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nМинимальное значение: 1.\nМаксимальное значение: 100.\nПо умолчанию: 20.\nЕсли значение 0 (не передано), то выставляем значение по умолчанию",
      },
      /**
       * Сдвиг.
       * По умолчанию: 0
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\nПо умолчанию: 0",
      },
    },
  },
  /**
   * Ошибка валидации постраничной пагинации по индикаторам.
   * Эти проверки выполняются до обращения в базу данных
   */
  "IndicatorPaging.ValidationError": {
    "kind": "class",
    "text": "Ошибка валидации постраничной пагинации по индикаторам.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Количество передано некорректно
       */
      "limit": {
        "type": "IndicatorPaging.ValidationError.LimitInvalid",
        "text": "Количество передано некорректно",
      },
      /**
       * Сдвиг передан некорректно
       */
      "offset": {
        "type": "IndicatorPaging.ValidationError.OffsetInvalid",
        "text": "Сдвиг передан некорректно",
      },
    },
  },
  /**
   * Причины:
   * - Значение количества < 0 или > 100
   */
  "IndicatorPaging.ValidationError.LimitInvalid": {
    "kind": "class",
    "text": "Причины:\n- Значение количества < 0 или > 100",
  },
  /**
   * Причины:
   * - Значение сдвига < 0
   */
  "IndicatorPaging.ValidationError.OffsetInvalid": {
    "kind": "class",
    "text": "Причины:\n- Значение сдвига < 0",
  },
  /**
   * Запрос создания задачи с клиента на сервере
   */
  "PostDeviceFullDuplexRequest": {
    "kind": "class",
    "text": "Запрос создания задачи с клиента на сервере",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Результат обработки устройства на клиенте
       */
      "postDeviceFullDuplexDeviceAsyncStatus": {
        "type": "PostDeviceFullDuplexRequest.DeviceAsyncStatus",
        "text": "Результат обработки устройства на клиенте",
      },
    },
  },
  /**
   * Результат обработки устройства на клиенте
   */
  "PostDeviceFullDuplexRequest.DeviceAsyncStatus": {
    "kind": "class",
    "text": "Результат обработки устройства на клиенте",
    "fields": {
      /**
       * Идентификатор ПУ
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор ПУ",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Успех
       */
      "data": {
        "type": "PostDeviceFullDuplexRequest.DeviceAsyncStatus.Success",
        "text": "Успех",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostDeviceFullDuplexRequest.DeviceAsyncStatus.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибки обработки устройства на клиенте
   */
  "PostDeviceFullDuplexRequest.DeviceAsyncStatus.Error": {
    "kind": "class",
    "text": "Ошибки обработки устройства на клиенте",
    "fields": {
      /**
       * Неизвестная ошибка
       */
      "postDeviceRequestUnknown": {
        "type": "PostDeviceFullDuplexRequest.DeviceAsyncStatus.Error.UnknownError",
        "text": "Неизвестная ошибка",
      },
      /**
       * Неверный IP
       */
      "postDeviceRequestIp": {
        "type": "PostDeviceFullDuplexRequest.DeviceAsyncStatus.Error.IpError",
        "text": "Неверный IP",
      },
      /**
       * Неверный порт
       */
      "postDeviceRequestPort": {
        "type": "PostDeviceFullDuplexRequest.DeviceAsyncStatus.Error.PortError",
        "text": "Неверный порт",
      },
      /**
       * Неверный сетевой адрес
       */
      "postDeviceRequestNetworkAddress": {
        "type": "PostDeviceFullDuplexRequest.DeviceAsyncStatus.Error.NetworkAddressError",
        "text": "Неверный сетевой адрес",
      },
    },
  },
  /**
   * Причины:
   *  - Устройство не найденно на данном IP адресе
   */
  "PostDeviceFullDuplexRequest.DeviceAsyncStatus.Error.IpError": {
    "kind": "class",
    "text": "Причины:\n - Устройство не найденно на данном IP адресе",
  },
  /**
   * Причины:
   *  - Неверный сетевой адрес
   */
  "PostDeviceFullDuplexRequest.DeviceAsyncStatus.Error.NetworkAddressError": {
    "kind": "class",
    "text": "Причины:\n - Неверный сетевой адрес",
  },
  /**
   * Причины:
   *  - Устройство отсутствует на порту
   */
  "PostDeviceFullDuplexRequest.DeviceAsyncStatus.Error.PortError": {
    "kind": "class",
    "text": "Причины:\n - Устройство отсутствует на порту",
  },
  /**
   * Неизвестная ошибка на стороне клиента
   */
  "PostDeviceFullDuplexRequest.DeviceAsyncStatus.Error.UnknownError": {
    "kind": "class",
    "text": "Неизвестная ошибка на стороне клиента",
    "fields": {
      /**
       * Произвольный текст ошибки на стороне клиента.
       * Отправляется в случае если в спецификации нет подходящей ошибки.
       * После анализа таких ошибок в спецификацию добавляется специальный тип под эту ошибку
       */
      "message": {
        "type": "string",
        "text": "Произвольный текст ошибки на стороне клиента.\nОтправляется в случае если в спецификации нет подходящей ошибки.\nПосле анализа таких ошибок в спецификацию добавляется специальный тип под эту ошибку",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Команда принята
   */
  "PostDeviceFullDuplexRequest.DeviceAsyncStatus.Success": {
    "kind": "class",
    "text": "Команда принята",
  },
  /**
   * Событие изменения ПУ на сервера
   */
  "PostDeviceFullDuplexResponse": {
    "kind": "class",
    "text": "Событие изменения ПУ на сервера",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Измененние ПУ на сервере
       */
      "postDevice": {
        "type": "PostDeviceResponse",
        "text": "Измененние ПУ на сервере",
      },
    },
  },
  /**
   * Запрос сохранения индикатора
   */
  "PostDeviceIndicatorRequest": {
    "kind": "class",
    "text": "Запрос сохранения индикатора",
    "fields": {
      /**
       * Индикатор
       */
      "data": {
        "type": "Indicator",
        "text": "Индикатор",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос сохранения индикатора
   */
  "PostDeviceIndicatorResponse": {
    "kind": "class",
    "text": "Ответ на запрос сохранения индикатора",
    "fields": {
      /**
       * Индикатор
       */
      "data": {
        "type": "Indicator",
        "text": "Индикатор",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostDeviceIndicatorResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса сохранения индикатора
   */
  "PostDeviceIndicatorResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса сохранения индикатора",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "Indicator.ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос замены прибора учета
   */
  "PostDeviceReplaceRequest": {
    "kind": "class",
    "text": "Запрос замены прибора учета",
    "fields": {
      /**
       * Идентификатор заменяемого прибора учета
       */
      "replaceDeviceId": {
        "type": "int32",
        "text": "Идентификатор заменяемого прибора учета",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Создаваемый прибор учета
       */
      "device": {
        "type": "Device",
        "text": "Создаваемый прибор учета",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на замену прибора учета
   */
  "PostDeviceReplaceResponse": {
    "kind": "class",
    "text": "Ответ на замену прибора учета",
    "fields": {
      /**
       * Созданный на замену ПУ
       */
      "data": {
        "type": "Device",
        "text": "Созданный на замену ПУ",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostDeviceReplaceResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка замены ПУ
   */
  "PostDeviceReplaceResponse.Error": {
    "kind": "class",
    "text": "Ошибка замены ПУ",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "Device.ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Не найден заменяемый ПУ
       */
      "replaceDeviceNotFound": {
        "type": "PostDeviceReplaceResponse.Error.ReplaceDeviceNotFound",
        "text": "Не найден заменяемый ПУ",
      },
      /**
       * Не удалось создать индикаторы нового ПУ
       */
      "createIndicatorsFail": {
        "type": "PostDeviceReplaceResponse.Error.CreateIndicatorsFail",
        "text": "Не удалось создать индикаторы нового ПУ",
      },
      /**
       * Попытка замены ПУ, привязанного ко многим ТУ
       */
      "multiLinkedMetricPoint": {
        "type": "PostDeviceReplaceResponse.Error.MultiLinkedMetricPoint",
        "text": "Попытка замены ПУ, привязанного ко многим ТУ",
      },
      /**
       * Заменяющий ПУ не привязан к дому заменяемого ПУ
       */
      "wrongBuilding": {
        "type": "PostDeviceReplaceResponse.Error.WrongBuilding",
        "text": "Заменяющий ПУ не привязан к дому заменяемого ПУ",
      },
      /**
       * Заменяемый ПУ не привязан к ТУ
       */
      "metricPointNotFound": {
        "type": "PostDeviceReplaceResponse.Error.MetricPointNotFound",
        "text": "Заменяемый ПУ не привязан к ТУ",
      },
    },
  },
  /**
   * Не удалось создать индикаторы нового ПУ
   */
  "PostDeviceReplaceResponse.Error.CreateIndicatorsFail": {
    "kind": "class",
    "text": "Не удалось создать индикаторы нового ПУ",
  },
  /**
   * Заменяемый ПУ не привязан к ТУ
   */
  "PostDeviceReplaceResponse.Error.MetricPointNotFound": {
    "kind": "class",
    "text": "Заменяемый ПУ не привязан к ТУ",
  },
  /**
   * Попытка замены ПУ, привязанного ко многим ТУ
   */
  "PostDeviceReplaceResponse.Error.MultiLinkedMetricPoint": {
    "kind": "class",
    "text": "Попытка замены ПУ, привязанного ко многим ТУ",
  },
  /**
   * Не найден заменяемый ПУ
   */
  "PostDeviceReplaceResponse.Error.ReplaceDeviceNotFound": {
    "kind": "class",
    "text": "Не найден заменяемый ПУ",
  },
  /**
   * Заменяющий ПУ не привязан к дому заменяемого ПУ
   */
  "PostDeviceReplaceResponse.Error.WrongBuilding": {
    "kind": "class",
    "text": "Заменяющий ПУ не привязан к дому заменяемого ПУ",
  },
  /**
   * Запрос сохранения ПУ
   */
  "PostDeviceRequest": {
    "kind": "class",
    "text": "Запрос сохранения ПУ",
    "fields": {
      /**
       * Прибор учета
       */
      "device": {
        "type": "Device",
        "text": "Прибор учета",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на изменение ПУ на сервере
   */
  "PostDeviceResponse": {
    "kind": "class",
    "text": "Ответ на изменение ПУ на сервере",
    "fields": {
      /**
       * ПУ
       */
      "data": {
        "type": "Device",
        "text": "ПУ",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostDeviceResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса сохранения ПУ
   */
  "PostDeviceResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса сохранения ПУ",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "Device.ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос сохранения связей ПУ и группы пользователя
   */
  "PutDeviceGroupAttachRequest": {
    "kind": "class",
    "text": "Запрос сохранения связей ПУ и группы пользователя",
    "fields": {
      /**
       * Связь ПУ и группы пользователя
       */
      "deviceGroup": {
        "type": "DeviceGroup",
        "text": "Связь ПУ и группы пользователя",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос сохранения связи ПУ и группы пользователя
   */
  "PutDeviceGroupAttachResponse": {
    "kind": "class",
    "text": "Ответ на запрос сохранения связи ПУ и группы пользователя",
  },
  /**
   * Запрос удаления связей ПУ и группы пользователя
   */
  "PutDeviceGroupDetachRequest": {
    "kind": "class",
    "text": "Запрос удаления связей ПУ и группы пользователя",
    "fields": {
      /**
       * Связь ПУ и группы пользователя
       */
      "deviceGroup": {
        "type": "DeviceGroup",
        "text": "Связь ПУ и группы пользователя",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления связи ПУ и группы пользователя
   */
  "PutDeviceGroupDetachResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления связи ПУ и группы пользователя",
  },
  /**
   * Запрос сохранения связей индикаторов и ТУ
   */
  "PutDeviceIndicatorMetricPointAttachRequest": {
    "kind": "class",
    "text": "Запрос сохранения связей индикаторов и ТУ",
    "fields": {
      /**
       * Связь индикатора и ТУ
       */
      "deviceIndicatorMetricPoint": {
        "type": "DeviceIndicatorMetricPoint",
        "text": "Связь индикатора и ТУ",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос сохранения связи индикатора и ТУ
   */
  "PutDeviceIndicatorMetricPointAttachResponse": {
    "kind": "class",
    "text": "Ответ на запрос сохранения связи индикатора и ТУ",
  },
  /**
   * Запрос удаления связей индикаторов и ТУ
   */
  "PutDeviceIndicatorMetricPointDetachRequest": {
    "kind": "class",
    "text": "Запрос удаления связей индикаторов и ТУ",
    "fields": {
      /**
       * Связь индикатора и ТУ
       */
      "deviceIndicatorMetricPoint": {
        "type": "DeviceIndicatorMetricPoint",
        "text": "Связь индикатора и ТУ",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления связи индикатора и ТУ
   */
  "PutDeviceIndicatorMetricPointDetachResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления связи индикатора и ТУ",
  },
  /**
   * Справочник типов учёта
   */
  "Device.MetricPoint.AccountingType": {
    "kind": "enum",
    "text": "Справочник типов учёта",
    "values": {
      /**
       * Значение не указано
       */
      "ACCOUNTING_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Коммерческий учёт
       */
      "COMMERCIAL": {
        "i": 1,
        "text": "Коммерческий учёт",
      },
      /**
       * Технический учёт
       */
      "TECHNICAL": {
        "i": 2,
        "text": "Технический учёт",
      },
    },
  },
  /**
   * Справочние типов энергоресурсов
   */
  "Device.MetricPoint.MetricType": {
    "kind": "enum",
    "text": "Справочние типов энергоресурсов",
    "values": {
      /**
       * Значение не указано
       */
      "METRIC_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Горячая вода
       */
      "HOT_WATER": {
        "i": 1,
        "text": "Горячая вода",
      },
      /**
       * Холодная вода
       */
      "COLD_WATER": {
        "i": 2,
        "text": "Холодная вода",
      },
      /**
       * Теплоэнергия
       */
      "HEAT": {
        "i": 3,
        "text": "Теплоэнергия",
      },
      /**
       * Газ
       */
      "GAS": {
        "i": 4,
        "text": "Газ",
      },
      /**
       * Электроэнергия
       */
      "ELECTRICITY": {
        "i": 5,
        "text": "Электроэнергия",
      },
    },
  },
  /**
   * Справочник типов номиналов первичных токов.
   * У выпускаемых трансформаторов тока (А)
   */
  "Device.MetricPoint.PrimaryCurrentType": {
    "kind": "enum",
    "text": "Справочник типов номиналов первичных токов.\nУ выпускаемых трансформаторов тока (А)",
    "values": {
      /**
       * Значение не указано
       */
      "PRIMARY_CURRENT_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * 1 (А)
       */
      "TT1A": {
        "i": 1,
        "text": "1 (А)",
      },
      /**
       * 5 (А)
       */
      "TT5A": {
        "i": 2,
        "text": "5 (А)",
      },
      /**
       * 10 (А)
       */
      "TT10A": {
        "i": 3,
        "text": "10 (А)",
      },
      /**
       * 15 (А)
       */
      "TT15A": {
        "i": 4,
        "text": "15 (А)",
      },
      /**
       * 20 (А)
       */
      "TT20A": {
        "i": 5,
        "text": "20 (А)",
      },
      /**
       * 30 (А)
       */
      "TT30A": {
        "i": 6,
        "text": "30 (А)",
      },
      /**
       * 40 (А)
       */
      "TT40A": {
        "i": 7,
        "text": "40 (А)",
      },
      /**
       * 50 (А)
       */
      "TT50A": {
        "i": 8,
        "text": "50 (А)",
      },
      /**
       * 75 (А)
       */
      "TT75A": {
        "i": 9,
        "text": "75 (А)",
      },
      /**
       * 80 (А)
       */
      "TT80A": {
        "i": 10,
        "text": "80 (А)",
      },
      /**
       * 100 (А)
       */
      "TT100A": {
        "i": 11,
        "text": "100 (А)",
      },
      /**
       * 150 (А)
       */
      "TT150A": {
        "i": 12,
        "text": "150 (А)",
      },
      /**
       * 200 (А)
       */
      "TT200A": {
        "i": 13,
        "text": "200 (А)",
      },
      /**
       * 300 (А)
       */
      "TT300A": {
        "i": 14,
        "text": "300 (А)",
      },
      /**
       * 400 (А)
       */
      "TT400A": {
        "i": 15,
        "text": "400 (А)",
      },
      /**
       * 500 (А)
       */
      "TT500A": {
        "i": 16,
        "text": "500 (А)",
      },
      /**
       * 600 (А)
       */
      "TT600A": {
        "i": 17,
        "text": "600 (А)",
      },
      /**
       * 750 (А)
       */
      "TT750A": {
        "i": 18,
        "text": "750 (А)",
      },
      /**
       * 800 (А)
       */
      "TT800A": {
        "i": 19,
        "text": "800 (А)",
      },
      /**
       * 1000 (А)
       */
      "TT1000A": {
        "i": 20,
        "text": "1000 (А)",
      },
      /**
       * 1200 (А)
       */
      "TT1200A": {
        "i": 21,
        "text": "1200 (А)",
      },
      /**
       * 1500 (А)
       */
      "TT1500A": {
        "i": 22,
        "text": "1500 (А)",
      },
      /**
       * 2000 (А)
       */
      "TT2000A": {
        "i": 23,
        "text": "2000 (А)",
      },
    },
  },
  /**
   * Справочник типов статусов
   */
  "Device.MetricPoint.StatusType": {
    "kind": "enum",
    "text": "Справочник типов статусов",
    "values": {
      /**
       * Значение не указано
       */
      "STATUS_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Активная
       */
      "ACTIVE": {
        "i": 1,
        "text": "Активная",
      },
      /**
       * Не активная
       * @deprecated
       */
      "WRONG": {
        "i": 2,
        "text": "Не активная",
        "options": {"deprecated":true},
      },
      /**
       * Архивная
       */
      "ARCHIVE": {
        "i": 3,
        "text": "Архивная",
      },
    },
  },
  /**
   * Справочник типов трубопроводов
   */
  "Device.PipeType": {
    "kind": "enum",
    "text": "Справочник типов трубопроводов",
    "values": {
      /**
       * Значение не указано
       */
      "PIPE_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Подающий
       */
      "INFEED": {
        "i": 1,
        "text": "Подающий",
      },
      /**
       * Циркуляционный
       */
      "CIRCULATING": {
        "i": 2,
        "text": "Циркуляционный",
      },
    },
  },
  /**
   * Справочник типов тарифных планов
   */
  "Device.PlanType": {
    "kind": "enum",
    "text": "Справочник типов тарифных планов",
    "values": {
      /**
       * Значение не указано
       */
      "PLAN_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Однотарифный
       */
      "SINGLE": {
        "i": 1,
        "text": "Однотарифный",
      },
      /**
       * Двухтарифный
       */
      "DOUBLE": {
        "i": 2,
        "text": "Двухтарифный",
      },
      /**
       * Трёхтарифный
       */
      "TRIPLE": {
        "i": 3,
        "text": "Трёхтарифный",
      },
    },
  },
  /**
   * Справочник типов номинальных нагрузок вторичных обмоток.
   * У трансформаторов тока (В*А)
   */
  "Device.SecondaryCurrentType": {
    "kind": "enum",
    "text": "Справочник типов номинальных нагрузок вторичных обмоток.\nУ трансформаторов тока (В*А)",
    "values": {
      /**
       * Значение не указано
       */
      "SECONDARY_CURRENT_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * 1 (А)
       */
      "TT1A": {
        "i": 1,
        "text": "1 (А)",
      },
      /**
       * 2 (А)
       */
      "TT2A": {
        "i": 2,
        "text": "2 (А)",
      },
      /**
       * 5 (А)
       */
      "TT5A": {
        "i": 3,
        "text": "5 (А)",
      },
    },
  },
  /**
   * Справочник типов статусов
   */
  "Device.StatusType": {
    "kind": "enum",
    "text": "Справочник типов статусов",
    "values": {
      /**
       * Значение не указано
       */
      "STATUS_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Получен клиентом, еще не сконфигурирован
       */
      "RECEIVED": {
        "i": 1,
        "text": "Получен клиентом, еще не сконфигурирован",
      },
      /**
       * Сконфигурирован клиентом, активен
       */
      "ACTIVE": {
        "i": 2,
        "text": "Сконфигурирован клиентом, активен",
      },
      /**
       * Обработан клиентом, возникла ошибка
       */
      "WRONG": {
        "i": 3,
        "text": "Обработан клиентом, возникла ошибка",
      },
      /**
       * Переведен в архивный статус
       */
      "ARCHIVE": {
        "i": 4,
        "text": "Переведен в архивный статус",
      },
      /**
       * Удален
       */
      "DELETE": {
        "i": 5,
        "text": "Удален",
      },
      /**
       * Отсоединен
       */
      "UNLINK": {
        "i": 6,
        "text": "Отсоединен",
      },
    },
  },
  /**
   * Справочник типов приборов учёта(ПУ)
   */
  "Device.Type": {
    "kind": "enum",
    "text": "Справочник типов приборов учёта(ПУ)",
    "values": {
      /**
       * Значение не указано
       */
      "TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Коммуникационный модуль
       */
      "HUB": {
        "i": 1,
        "text": "Коммуникационный модуль",
      },
      /**
       * Счетчик импульсов - регистратор
       */
      "PULSE_COUNTER_RECORDER": {
        "i": 2,
        "text": "Счетчик импульсов - регистратор",
      },
      /**
       * Счетчик импульсов - регистратор LoRaWAN
       */
      "PULSE_COUNTER_RECORDER_LR": {
        "i": 3,
        "text": "Счетчик импульсов - регистратор LoRaWAN",
      },
      /**
       * Прибор учета расхода коммунальных услуг
       */
      "METERING_DEVICE": {
        "i": 4,
        "text": "Прибор учета расхода коммунальных услуг",
      },
      /**
       * Конвертер интерфейсов
       */
      "INTERFACE_CONVERTER": {
        "i": 5,
        "text": "Конвертер интерфейсов",
      },
      /**
       * M-BUS концентратор
       */
      "M_BUS_HUB": {
        "i": 6,
        "text": "M-BUS концентратор",
      },
      /**
       * Модуль связи LoRaWAN
       */
      "COMMUNICATION_MODULE_LR": {
        "i": 7,
        "text": "Модуль связи LoRaWAN",
      },
      /**
       * Базовая станция LoRaWAN
       */
      "BASE_LR": {
        "i": 8,
        "text": "Базовая станция LoRaWAN",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки
   */
  "DeviceGroupPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов сортировки
   */
  "DeviceGroupPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По Идентификатору группы пользователя
       */
      "GROUP_ID": {
        "i": 1,
        "text": "По Идентификатору группы пользователя",
      },
      /**
       * По ПУ
       */
      "DEVICE_ID": {
        "i": 2,
        "text": "По ПУ",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки
   */
  "DeviceIndicatorMetricPointPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов сортировки
   */
  "DeviceIndicatorMetricPointPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По Идентификатору индикатора
       */
      "INDICATOR_ID": {
        "i": 1,
        "text": "По Идентификатору индикатора",
      },
      /**
       * По По Идентификатору ТУ
       */
      "METRIC_POINT_ID": {
        "i": 2,
        "text": "По По Идентификатору ТУ",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки
   */
  "DevicePaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки
   */
  "DevicePaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По идентификатору
       */
      "ID": {
        "i": 1,
        "text": "По идентификатору",
      },
    },
  },
  /**
   * Справочник типа архивности показаний.
   * Используется для указания за какой период произошло измерение.
   * По умолчанию CURRENT
   */
  "Indicator.ArchiveType": {
    "kind": "enum",
    "text": "Справочник типа архивности показаний.\nИспользуется для указания за какой период произошло измерение.\nПо умолчанию CURRENT",
    "values": {
      /**
       * Значение не указано
       */
      "ARCHIVE_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Текущие показания
       */
      "CURRENT": {
        "i": 1,
        "text": "Текущие показания",
      },
      /**
       * За 30 мин
       */
      "HALFHOUR": {
        "i": 2,
        "text": "За 30 мин",
      },
      /**
       * За час
       */
      "HOUR": {
        "i": 3,
        "text": "За час",
      },
      /**
       * За сутки
       */
      "DAY": {
        "i": 4,
        "text": "За сутки",
      },
      /**
       * За месяц
       */
      "MONTH": {
        "i": 5,
        "text": "За месяц",
      },
      /**
       * За год
       */
      "YEAR": {
        "i": 6,
        "text": "За год",
      },
    },
  },
  /**
   * Справочник типов измерений
   */
  "Indicator.SignType": {
    "kind": "enum",
    "text": "Справочник типов измерений",
    "values": {
      /**
       * Значение не указано
       */
      "SIGN_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Абсолютный показатель
       */
      "ABSOLUTE_DS": {
        "i": 1,
        "text": "Абсолютный показатель",
      },
      /**
       * Абсолютный расход ресурса
       */
      "ABSOLUTE_RC": {
        "i": 2,
        "text": "Абсолютный расход ресурса",
      },
      /**
       * Интервальный показатель состояния
       */
      "INTERVAL_DS": {
        "i": 3,
        "text": "Интервальный показатель состояния",
      },
      /**
       * Интервальный расход ресурса
       */
      "INTERVAL_RC": {
        "i": 4,
        "text": "Интервальный расход ресурса",
      },
      /**
       * Текущее состояние
       */
      "CURRENT_DS": {
        "i": 5,
        "text": "Текущее состояние",
      },
      /**
       * Текущее состояние ресурса
       */
      "CURRENT_RS": {
        "i": 6,
        "text": "Текущее состояние ресурса",
      },
      /**
       * Объём
       */
      "VOLUME": {
        "i": 7,
        "text": "Объём",
      },
      /**
       * Параметр конфигурации
       */
      "PARAMETER": {
        "i": 8,
        "text": "Параметр конфигурации",
      },
      /**
       * Флаг состояния
       */
      "FLAG": {
        "i": 9,
        "text": "Флаг состояния",
      },
    },
  },
  /**
   * Справочник типов единиц измерений
   */
  "Indicator.UnitType": {
    "kind": "enum",
    "text": "Справочник типов единиц измерений",
    "values": {
      /**
       * Значение не указано
       */
      "UNIT_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Процент
       */
      "PERCENT": {
        "i": 1,
        "text": "Процент",
      },
      /**
       * Градус по Цельсию
       */
      "C": {
        "i": 2,
        "text": "Градус по Цельсию",
      },
      /**
       * Ватт
       */
      "WT": {
        "i": 3,
        "text": "Ватт",
      },
      /**
       * Гигакалория
       */
      "GKAL": {
        "i": 4,
        "text": "Гигакалория",
      },
      /**
       * Количество
       */
      "VALUE": {
        "i": 5,
        "text": "Количество",
      },
      /**
       * Киловaтт-час
       */
      "KWH": {
        "i": 6,
        "text": "Киловaтт-час",
      },
      /**
       * Килограмм на квадратный сантиметр
       */
      "KG_CM2": {
        "i": 7,
        "text": "Килограмм на квадратный сантиметр",
      },
      /**
       * Килограмм-сила на квадратный сантиметр
       */
      "KGF_CM2": {
        "i": 8,
        "text": "Килограмм-сила на квадратный сантиметр",
      },
      /**
       * Кубический метр
       */
      "M3": {
        "i": 9,
        "text": "Кубический метр",
      },
      /**
       * Кубический метр в час
       */
      "M3_H": {
        "i": 10,
        "text": "Кубический метр в час",
      },
      /**
       * Мегапаскаль
       */
      "MPA": {
        "i": 11,
        "text": "Мегапаскаль",
      },
      /**
       * Миллисекунда
       */
      "MS": {
        "i": 12,
        "text": "Миллисекунда",
      },
      /**
       * Флаг состояния
       */
      "BOOLEAN": {
        "i": 13,
        "text": "Флаг состояния",
      },
      /**
       * Тонна
       */
      "T": {
        "i": 14,
        "text": "Тонна",
      },
      /**
       * Тонна в час
       */
      "T_H": {
        "i": 15,
        "text": "Тонна в час",
      },
      /**
       * Час
       */
      "H": {
        "i": 16,
        "text": "Час",
      },
      /**
       * Безразмерная величина
       */
      "NON_MEASURABLE": {
        "i": 17,
        "text": "Безразмерная величина",
      },
      /**
       * Импульс
       */
      "IMP": {
        "i": 18,
        "text": "Импульс",
      },
      /**
       * Джоуль
       */
      "J": {
        "i": 19,
        "text": "Джоуль",
      },
      /**
       * Килоджоуль
       */
      "KJ": {
        "i": 20,
        "text": "Килоджоуль",
      },
      /**
       * Гигаджоуль
       */
      "GJ": {
        "i": 21,
        "text": "Гигаджоуль",
      },
      /**
       * Ватт-час
       */
      "WTH": {
        "i": 22,
        "text": "Ватт-час",
      },
      /**
       * Киловатт
       */
      "KWT": {
        "i": 23,
        "text": "Киловатт",
      },
      /**
       * Минута
       */
      "MIN": {
        "i": 24,
        "text": "Минута",
      },
      /**
       * Секунда
       */
      "S": {
        "i": 25,
        "text": "Секунда",
      },
    },
  },
  /**
   * Посредники получения показаний
   */
  "Indicator.VendorType": {
    "kind": "enum",
    "text": "Посредники получения показаний",
    "values": {
      /**
       * Значение не указано
       */
      "VENDOR_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Энвайро
       */
      "ENVIRO": {
        "i": 1,
        "text": "Энвайро",
      },
      /**
       * Лартех
       */
      "LARTECH": {
        "i": 2,
        "text": "Лартех",
      },
      /**
       * РТК
       */
      "RTK": {
        "i": 3,
        "text": "РТК",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки
   */
  "IndicatorPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов сортировки
   */
  "IndicatorPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По уникальному ключу
       */
      "ID": {
        "i": 1,
        "text": "По уникальному ключу",
      },
      /**
       * По типу измерений
       */
      "SIGN_TYPE": {
        "i": 2,
        "text": "По типу измерений",
      },
      /**
       * По Прибору учета
       */
      "DEVICE_ID": {
        "i": 3,
        "text": "По Прибору учета",
      },
      /**
       * По Дате создания
       */
      "CREATED_AT": {
        "i": 4,
        "text": "По Дате создания",
      },
    },
  },
}